<ng-container *transloco="let convert">
  <div *ngIf="showBanner && vehicleRemovedSuccessMsg" class="my-3">
    <app-banner data-testid="bidlist-inventory-item-banner-success" (close)="closeBanner()" (undo)="undoBanner()" *ngIf="showBanner" [bannerConfig]="banner"
      [bannerTextSuccesfullyRemoved]="bannerTextSuccesfullyRemoved" [title]="title"
      [vehicleRemovedSuccessMsg]="vehicleRemovedSuccessMsg"> </app-banner>
  </div>
  <div *ngIf="showBanner && !vehicleRemovedSuccessMsg" class="my-3">
    <app-banner data-testid="bidlist-inventory-item-banner-error" (close)="closeBanner()" (undo)="undoBanner()" *ngIf="showBanner" [bannerConfig]="banner"
      [bannerTextSuccesfullyRemoved]="bannerTextSuccesfullyRemoved" [bannerErrorCode]="bannerErrorCode" [title]="title"
      [vehicleRemovedSuccessMsg]="vehicleRemovedSuccessMsg"> </app-banner>
  </div>
  <ng-container *ngIf="!isListView; else listview">

    <div class="inventory-item__card border border-dark wrapper pb-2 pe-2 ps-2 pt-1"
      *ngIf="bidItem && bidItem.itemDetail && !hide" data-track-region="Card">
      <div [class]="classList">
        <div class="stockwave-highlight-element">
          <div class="inventory-item__header" [ngClass]="{'shared-list-selected': isSharedListVehicleSelected}">
            <div class="d-flex flex-row">
              <ng-container *ngIf="isSharedListCheckboxEnabled()">
                <div class="shared-list-checkbox-controls-card-view">
                  <div [class]="checkboxClassList">
                    <input data-testid="bidlist-inventory-item-card-shared-checkbox" *ngIf="isActiveAuctionButtons()" type="checkbox" class="custom-control-input"
                      [id]="'bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelSelectVehicleCheckbox')"
                      (click)="toggleVehicleCheckboxSelected()" [checked]="isVehicleCheckboxSelected" [disabled]="!isPendingBuyerAction()" />
                    <label [for]="'bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                      class="custom-control-label"></label>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="!isSharedList">
                <ng-container *ngIf="multiVehicleRemovalEnabled && this.bidListMultiSelectEnabled; else SINGLEREMOVAL">
                  <div *ngIf=isBidListCheckboxEnabled() class="shared-list-checkbox-controls-card-view">
                    <div [class]="checkboxClassList">
                      <input data-testid="bidlist-inventory-item-card-bidlist-checkbox" type="checkbox" class="custom-control-input" [id]="'bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                             (click)="toggleVehicleCheckboxSelected()" [checked]="isVehicleCheckboxSelected" [disabled]="!isRemovableBidListItem()">
                      <label [for]="'bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid" class="custom-control-label"></label>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <header class="inventory-item__header-info flex-sm-row flex-md-column flex-grow">
                <div class="inventory-item__header-details me-sm-3 me-md-0">
                  <div class="stockwave-light-bulb-container"></div>
                  <div class="d-flex align-items-md-end flex-column flex-md-row flex-md-wrap">
                    <a [attr.data-testid]="'bidlist-inventory-item-header-title-link-' + index" *ngIf="urlBaseExternal" class="h5 inventory-item__title text-primary align-self-stretch"
                      [href]="vdpLink" target="_blank" [attr.aria-label]="
                    title +
                    ' - ' +
                    (bidItem.buyerAuctionItemStatus | badgeStatus).text +
                    convert('vehicles.bidlistInventoryItem.ariaLabelViewVehiclePage')
                  " data-track-elem="card id" [attr.data-track-name]="bidItem.inventoryItemUuid + ' - VDP'"
                      [id]="'vehicle_description_text_' + index + '_' + urlBaseExternal" tabindex="0">
                      {{ title }}
                    </a>
                    <a [attr.data-testid]="'bidlist-inventory-item-header-title-link-' + index" *ngIf="!urlBaseExternal" class="h5 inventory-item__title text-primary align-self-stretch" [routerLink]="vdpLink"
                      (click)="goToVdp()" (keypress)="goToVdp()" target="_self" [attr.aria-label]="
                    title +
                    ' - ' +
                    (bidItem.buyerAuctionItemStatus | badgeStatus).text +
                    convert('vehicles.bidlistInventoryItem.ariaLabelViewVehiclePage')
                  " data-track-elem="card id"
                    [id]="'vehicle_description_text_' + index + '_' + urlBaseExternal" tabindex="0" allytm-click-tagged="true">
                      {{ title }}
                    </a>
                    <div class="inventory-item__status">
                      <app-auction-badge data-testid="bidlist-inventory-item-header-status-badge" text="{{ (bidItem.buyerAuctionItemStatus | badgeStatus).text }}"
                        hasIcon="{{ (bidItem.buyerAuctionItemStatus | badgeStatus).hasIcon }}"
                        outline="{{ (bidItem.buyerAuctionItemStatus | badgeStatus).outline }}"
                        variant="{{ (bidItem.buyerAuctionItemStatus | badgeStatus).variant }}">
                      </app-auction-badge>
                    </div>
                  </div>
                  <div class="inventory-item__vin d-flex fw-bold text-uppercase flex-column align-items-start flex-md-row"
                    [id]="'vehicle_vin_text_' + index">
                    <span>{{ bidItem.itemDetail.vin ? bidItem.itemDetail.vin : '' }}</span>
                    @if(isStockNumberEnabled) {
                      <span class="text-uppercase">{{ translations.textStockUnit }} <strong> {{ stockNumber }} </strong></span>
                    }
                    @if(showInspectionSeries) {
                      <span class="text-uppercase">{{ translations.textInspectionSeries }}: <strong> {{ inspectionSeries }}  </strong></span>
                    }
                  </div>
                </div>
                <sw-icon-container-hook></sw-icon-container-hook>
              </header>
            </div>
            <div class="inventory-item__header-action d-none d-md-flex flex-column flex-nowrap flex-grow-1 ps-4 align-items-end justify-content-sm-end">
              <aside *ngIf="showSellerOfferExpiry && !isSharedList" class="text-end sl-notif"
                [attr.aria-label]="translations.partOf">
                  <app-shared-list-warning
                    textPartOf="{{ translations.partOf }}"
                    textSharedList="{{ translations.currentListType }}"
                    [isInServiceVehiclesEnabled]="isInServiceVehiclesEnabled"
                    [vehicleTypeCode]="vehicleTypeCode"
                    [sharedByUuid]="bidItem.offerListSenderUserUuid"
                    [offerListUuid]="bidItem.offerListUuid"
                  ></app-shared-list-warning>
              </aside>

              <div class="mt-1 d-flex flex-row">
                <ng-container>
                  <ng-container *ngIf="isSharedList && activeAuctionButtons">
                    <ng-content *ngTemplateOutlet="desktopActiveAuctionButtons"></ng-content>
                  </ng-container>
                  <ng-container *ngIf="!isSharedList">
                    <ng-content *ngTemplateOutlet="desktopWithdrawButton"></ng-content>
                    <ng-content *ngTemplateOutlet="desktopBidButton"></ng-content>
                    <ng-content *ngTemplateOutlet="desktopOfferButton"></ng-content>
                    <ng-content *ngTemplateOutlet="desktopBuyNowButton"></ng-content>
                    <ng-content *ngTemplateOutlet="desktopViewSimilarButton"></ng-content>
                  </ng-container>
                </ng-container>

                <button data-testid="bidlist-inventory-item-header-collapse-button" *ngIf="!isCollapsed" data-track-elem="icon" data-track-name="collapse" class="collapse-btn"
                        [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelCollapseVehicleInfo')"
                        (click)="toggleCollapsedState()" [attr.aria-expanded]="!isCollapsed">
                  <img src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-collapse.svg"
                       alt="{{ convert('vehicles.bidlistInventoryItem.ariaLabelCollapseVehicleInfo') }}" />
                </button>
                <button data-testid="bidlist-inventory-item-header-expand-button" *ngIf="isCollapsed" data-track-elem="icon" data-track-name="expand" class="collapse-btn"
                        [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelExpandVehicleInfo')"
                        (click)="toggleCollapsedState()" [attr.aria-expanded]="!isCollapsed">
                  <img src="/ui/assets/assets-{{ tenantName }}/{{ tenantName }}-expand.svg"
                       alt="{{ convert('vehicles.bidlistInventoryItem.ariaLabelExpandVehicleInfo') }}" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="inventory-item__body">
          <div class="inventory-item__image-wrap" *ngIf="!isCollapsed">
            <ng-container *ngIf="!bidItem.itemDetail.image">
              <ng-content *ngTemplateOutlet="imagePlaceholder"></ng-content>
            </ng-container>
            <ng-container *ngIf="bidItem.itemDetail.image">
              <ng-content *ngTemplateOutlet="image"></ng-content>
            </ng-container>
          </div>

          <div class="inventory-item__actions">
            <div *ngIf="showSellerOfferExpiry && !isSharedList" class="mb-3 text-start"
              [attr.aria-label]="convert('vehicles.bidlistInventoryItem.textPartOf')">
              <app-shared-list-warning
                textPartOf="{{ translations.partOf }}"
                textSharedList="{{ translations.currentListType }}"
                [isInServiceVehiclesEnabled]="isInServiceVehiclesEnabled"
                [vehicleTypeCode]="vehicleTypeCode"
                [sharedByUuid]="bidItem.offerListSenderUserUuid"
                [offerListUuid]="bidItem.offerListUuid"
              ></app-shared-list-warning>
            </div>
            <div class="inventory-item__actions-btn">
              <ng-container>
                <ng-container *ngIf="isSharedList && activeAuctionButtons">
                  <ng-content *ngTemplateOutlet="mobileActiveAuctionButtons"></ng-content>
                </ng-container>
                <ng-container *ngIf="!isSharedList">
                  <ng-content *ngTemplateOutlet="mobileWithdrawButton"></ng-content>
                  <ng-content *ngTemplateOutlet="mobileBidButton"></ng-content>
                  <ng-content *ngTemplateOutlet="mobileOfferButton"></ng-content>
                  <ng-content *ngTemplateOutlet="mobileBuyNowButton"></ng-content>
                  <ng-content *ngTemplateOutlet="mobileViewSimilarButton"></ng-content>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="inventory-item__detail-tabs">
            <tabset [justified]="true">
              <tab heading="Seller">
                <ng-container *ngTemplateOutlet="sellerTab"></ng-container>
              </tab>
              <tab heading="Details" class="auctionItem-detail-tab">
                <ng-container *ngTemplateOutlet="detailsTab"></ng-container>
              </tab>
              <tab heading="Pricing">
                <ng-container *ngTemplateOutlet="pricingTab"></ng-container>
              </tab>
            </tabset>
          </div>
          <div class="inventory-item__details">
            <ng-container *ngIf="isResult">
              <ng-container *ngIf="!isCollapsed">
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="resultCol1"></ng-container>
                </div>
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="resultCol2"></ng-container>
                </div>
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="resultCol3"></ng-container>
                </div>
              </ng-container>
              <ng-container *ngIf="isCollapsed">
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="collapsedCol1"></ng-container>
                </div>
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="collapsedCol2"></ng-container>
                </div>
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="collapsedCol3"></ng-container>
                </div>
                <div class="inventory-item__details-col">
                  <ng-container *ngTemplateOutlet="collapsedCol4"></ng-container>
                </div>
              </ng-container>
            </ng-container>
            @if (vehicleTypeCode !== 'ISV') {
            <div class="w-100 mt-1" *ngIf="!editingComment">
              <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelMyComments') }}"
                class="mb-0 inventory-item__comment">
                <span [id]="'vehicle_comments_text_' + index">{{ get('buyerComment', 'N/A') }}</span>
                <a data-testid="bidlist-inventory-item-details-edit-comment-link" href="#" *ngIf="isEditable" (click)="editComment($event)"
                  class="ps-2 pe-1 edit-delivery__link text-bold" data-track-elem="button"
                  data-track-name="My Comments | Edit" [id]="'vehicle_comments_edit_link_' + index">{{
                  convert('vehicles.bidlistInventoryItem.textEdit') }}</a>
              </app-datalist-item>
            </div>
            <div class="w-100 mt-1" *ngIf="editingComment && !isMobile">
              <app-edit-comment data-testid="bidlist-inventory-item-details-edit-comment" [comment]="bidItem.buyerComment" (cancelEvent)="cancelEditComment()"
                (updateEvent)="updateComment($event); cancelEditComment()" [index]="index"></app-edit-comment>
            </div>
            }
          </div>
          @if (vehicleTypeCode !== 'ISV') {
          <div class="w-100 mt-1 inventory-item__comment-mobile" *ngIf="!editingComment">
            <app-datalist-item label="My Comments" class="mb-0">
              {{ get('buyerComment', 'N/A') }}
              <a data-testid="bidlist-inventory-item-details-edit-comment-mobile-link" href="#" *ngIf="isEditable" (click)="editComment($event)"
                class="ps-2 pe-1 edit-delivery__link text-bold" data-track-elem="button"
                data-track-name="My Comments | Edit">{{ convert('vehicles.bidlistInventoryItem.textEdit') }}</a>
            </app-datalist-item>
          </div>
          <div class="w-100 mt-1 inventory-item__comment-mobile" *ngIf="editingComment && isMobile">
            <app-edit-comment [comment]="bidItem.buyerComment" (cancelEvent)="cancelEditComment()"
              (updateEvent)="updateComment($event)"></app-edit-comment>
          </div>
        }
        </div>
      </div>
      <ng-template #SINGLEREMOVAL>
        <button data-testid="bidlist-inventory-item-actions-remove-button" data-track-elem="button" data-track-name="Remove From Bidlist"
          class="inventory-item__icon-wrapper desktop_icon" (click)="removeFromBidList()"
          [attr.allytmln]="'removeBidListBuyAction'"
          [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelRemoveBidList', { title: title })"
          [id]="'vehicle_remove_from_bid_list_icon_' + index">
          <i class="allycon-minus-outline text-primary" aria-hidden="true"></i>
        </button>
        <div data-testid="bidlist-inventory-item-actions-remove-mobile-button" data-track-elem
               ="button" data-track-name="Remove From Bidlist" class="remove_icon_mobile"
             (click)="removeFromBidList()" [attr.allytmln]="'removeBidListBuyAction'">
          <i class="allycon-minus-outline text-primary" aria-hidden="true"></i>
        </div>
      </ng-template>
      <ng-template #viewServiceFee>
        <a data-testid="bidlist-inventory-item-pricing-fee-schedule-link" *ngIf="showViewFeeSchedule && auctionFeeScheduleEnabled" class="service_fee_schedule_link" href="#"
          class="pe-1 text-bold do-not-print mobileFeeLink" (click)="openFeeScheduleModal($event)"
          [attr.aria-label]="convert('vehicles.bidlistInventoryItem.textViewFeeSchedule')" data-track-elem="button"
          data-track-trigger="modal" allytmln="View Fee Schedule"
          [attr.data-track-name]="convert('vehicles.bidlistInventoryItem.textViewFeeSchedule')" type="button">{{
          convert('vehicles.bidlistInventoryItem.textViewFeeSchedule') }}</a>
      </ng-template>

      <ng-template #sellerTab>
        <div class="row tab-mobile">
          <div class="col">
            <ng-content *ngTemplateOutlet="seller"></ng-content>
            <ng-content *ngTemplateOutlet="location"></ng-content>
          </div>
          <div class="col">
            <ng-container *ngIf="showShippingQuote">
              <app-transportation-estimate [transportationQuote]="bidItem.transportationQuote"
                [transportationTranslate]="bidlistInventoryItemTranslations.transTranslations" mode="estimate"
                [showDeliveryLink]="isDeliveryLinkDisplayed" [index]="index"
                [inventoryItemUuid]="bidItem.inventoryItemUuid"
                (fireEventOnClick)="fireEventOnAnchorClick($event)">
              </app-transportation-estimate>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <ng-template #detailsTab>
        <div class="row tab-mobile">
          <div class="col">
            <ng-content *ngTemplateOutlet="odometer"></ng-content>
            <ng-container *ngIf="displayBuyerTip">
              <ng-content *ngTemplateOutlet="tips"></ng-content>
            </ng-container>
            <ng-container *ngIf="showDelivery">
              <ng-content *ngTemplateOutlet="delivery"></ng-content>
            </ng-container>
            <ng-content *ngTemplateOutlet="serviceFee"></ng-content>
          </div>
          <div class="col">
            <ng-content *ngTemplateOutlet="status"></ng-content>
            <ng-content *ngTemplateOutlet="disclosures"></ng-content>
          </div>
        </div>
      </ng-template>

      <ng-template #pricingTab>
        <div class="row tab-mobile">
          <div class="col-6">
            <ng-container *ngIf="!isSharedList">
              <ng-content *ngTemplateOutlet="openingPrice"></ng-content>
            </ng-container>
            <ng-container
              *ngIf="!isSharedList && showVOCItems && bidItem.dealershipLastBidAmount && get('buyerAuctionItemStatus') === 'SOLD'">
              <ng-content *ngTemplateOutlet="lastBidAmount"></ng-content>
            </ng-container>
            <ng-container *ngIf="!bidItem.highestBidderName && !isSharedList">
              <ng-content *ngTemplateOutlet="buyNow"></ng-content>
            </ng-container>
            <ng-container *ngIf="showWinningOffer">
              <ng-content *ngTemplateOutlet="winningOffer"></ng-content>
            </ng-container>
            <ng-container *ngIf="bidItem.highestBidderName && !isSharedList">
              <ng-content *ngTemplateOutlet="highBidder"></ng-content>
            </ng-container>
            <ng-container *ngIf="this.vehicleTypeCode !== 'ISV'">
              <ng-content *ngTemplateOutlet="dealership"></ng-content>
            </ng-container>
            <ng-content *ngTemplateOutlet="creditLine"></ng-content>
            <ng-content *ngTemplateOutlet="bidHistoryLink"></ng-content>
          </div>
          <div class="col-6">
            <ng-content *ngTemplateOutlet="spread"></ng-content>
            <ng-container *ngIf="get('offerAmount') !== null && get('offerAmount') !== '-'">
              <ng-content *ngTemplateOutlet="offeredAmount"></ng-content>
            </ng-container>
            <ng-container *ngIf="showTotalPurchasePrice">
              <ng-content *ngTemplateOutlet="totalPurchasePrice"></ng-content>
            </ng-container>
            <ng-container *ngIf="isSharedList">
              <ng-content *ngTemplateOutlet="sellerOfferExpiry"></ng-content>
            </ng-container>
            <ng-container *ngIf="this.vehicleTypeCode !== 'ISV'">
              <ng-content *ngTemplateOutlet="auctionStatusTime"></ng-content>
            </ng-container>
          </div>
        </div>
      </ng-template>

      <ng-template #resultCol1>
        <ng-content *ngTemplateOutlet="seller"></ng-content>
        <ng-content *ngTemplateOutlet="location"></ng-content>
        <ng-container *ngIf="displayBuyerTip">
          <ng-content *ngTemplateOutlet="tips"></ng-content>
        </ng-container>
        <ng-content *ngTemplateOutlet="odometer"></ng-content>
        <ng-container *ngIf="showDelivery">
          <ng-content *ngTemplateOutlet="delivery"></ng-content>
        </ng-container>
        <ng-content *ngTemplateOutlet="serviceFee"></ng-content>
      </ng-template>

      <ng-template #resultCol2>
        <ng-content *ngTemplateOutlet="spread"></ng-content>
        <ng-content *ngTemplateOutlet="status"></ng-content>
        <ng-content *ngTemplateOutlet="disclosures"></ng-content>
        <ng-container *ngIf="showShippingQuote">
          <app-transportation-estimate [transportationQuote]="bidItem.transportationQuote"
            [transportationTranslate]="bidlistInventoryItemTranslations.transTranslations" mode="estimate"
            [showDeliveryLink]="isDeliveryLinkDisplayed" [index]="index"
            [inventoryItemUuid]="bidItem.inventoryItemUuid"
            (fireEventOnClick)="fireEventOnAnchorClick($event)">
          </app-transportation-estimate>
        </ng-container>
        <ng-container *ngIf="showSpareKeyFee">
          <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelSpareKeyFee') }}"
            [identifier]="'vehicle_spare_key_fee_text_' + index"
            [attr.data-testid]="'bidlist-inventory-item-details-spare-key-fee-' + index">
            {{ formatCurrency(platformSpareKeyFee, true) }} {{ convert('vehicles.bidlistInventoryItem.textOptional') }}
          </app-datalist-item>
        </ng-container>
      </ng-template>

      <ng-template #resultCol3>
        <ng-container *ngIf="!bidItem.highestBidderName && !isSharedList">
          <ng-content *ngTemplateOutlet="buyNow"></ng-content>
        </ng-container>
        <ng-container *ngIf="bidItem.highestBidderName && !isSharedList">
          <ng-content *ngTemplateOutlet="highBidder"></ng-content>
        </ng-container>
        <ng-container *ngIf="!isSharedList">
          <ng-content *ngTemplateOutlet="openingPrice"></ng-content>
        </ng-container>
        <ng-container *ngIf="showWinningOffer">
          <ng-content *ngTemplateOutlet="winningOffer"></ng-content>
        </ng-container>
        <ng-container
          *ngIf="!isSharedList && showVOCItems && bidItem.dealershipLastBidAmount && get('buyerAuctionItemStatus') === 'SOLD'">
          <ng-content *ngTemplateOutlet="lastBidAmount"></ng-content>
        </ng-container>
        <ng-container *ngIf="get('offerAmount') !== null && get('offerAmount') !== '-'">
          <ng-content *ngTemplateOutlet="offeredAmount"></ng-content>
        </ng-container>
        <ng-container *ngIf="showTotalPurchasePrice">
          <ng-content *ngTemplateOutlet="totalPurchasePrice"></ng-content>
        </ng-container>
        <ng-container *ngIf="isSharedList">
          <ng-content *ngTemplateOutlet="sellerOfferExpiry"></ng-content>
        </ng-container>
        <ng-container *ngIf="this.vehicleTypeCode !== 'ISV'">
          <ng-content *ngTemplateOutlet="auctionStatusTime"></ng-content>
        </ng-container>
        <ng-container *ngIf="this.vehicleTypeCode !== 'ISV'">
          <ng-content *ngTemplateOutlet="dealership"></ng-content>
        </ng-container>
        <ng-content *ngTemplateOutlet="creditLine"></ng-content>
        <ng-content *ngTemplateOutlet="bidHistoryLink"></ng-content>
      </ng-template>

      <ng-template #collapsedCol1>
        <ng-container *ngIf="!isSharedList">
          <ng-content *ngTemplateOutlet="openingPrice"></ng-content>
        </ng-container>
        <ng-container
          *ngIf="!isSharedList && showVOCItems && bidItem.dealershipLastBidAmount && get('buyerAuctionItemStatus') === 'SOLD'">
          <ng-content *ngTemplateOutlet="lastBidAmount"></ng-content>
        </ng-container>
        <ng-container *ngIf="!bidItem.highestBidderName && !isSharedList">
          <ng-content *ngTemplateOutlet="buyNow"></ng-content>
        </ng-container>
        <ng-container *ngIf="bidItem.highestBidderName && !isSharedList">
          <ng-content *ngTemplateOutlet="highBidder"></ng-content>
        </ng-container>
        <ng-container *ngIf="showWinningOffer">
          <ng-content *ngTemplateOutlet="winningOffer"></ng-content>
        </ng-container>
      </ng-template>

      <ng-template #collapsedCol2>
        <ng-content *ngTemplateOutlet="location"></ng-content>
        <ng-content *ngTemplateOutlet="odometer"></ng-content>
      </ng-template>

      <ng-template #collapsedCol3>
        <ng-content *ngTemplateOutlet="serviceFee"></ng-content>
        <ng-content *ngTemplateOutlet="status"></ng-content>
      </ng-template>

      <ng-template #collapsedCol4>
        <ng-container *ngIf="get('offerAmount') !== null && get('offerAmount') !== '-'">
          <ng-content *ngTemplateOutlet="offeredAmount"></ng-content>
        </ng-container>
        <ng-container *ngIf="showTotalPurchasePrice">
          <ng-content *ngTemplateOutlet="totalPurchasePrice"></ng-content>
        </ng-container>
        <ng-container *ngIf="isSharedList">
          <ng-content *ngTemplateOutlet="sellerOfferExpiry"></ng-content>
        </ng-container>
        <ng-container *ngIf="this.vehicleTypeCode !== 'ISV'">
          <ng-content *ngTemplateOutlet="auctionStatusTime"></ng-content>
        </ng-container>
      </ng-template>

      <ng-template #seller>
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelSeller') }}"
          [value]="get('seller.name', 'N/A')" class="ellipsis-overflow" [identifier]="'vehicle_seller_text_' + index">
          <div class="view-all-by-seller-container">
            <app-view-all-by-seller-link [sellerName]="get('seller.name')"></app-view-all-by-seller-link>
          </div>
        </app-datalist-item>
      </ng-template>
      <ng-template #location>
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelLocation') }}" *ngIf="
        bidItem.storageLocation &&
        bidItem.storageLocation.city !== '' &&
        bidItem.storageLocation.state !== '' &&
        bidItem.storageLocation.city &&
        bidItem.storageLocation.state
      " [identifier]="'vehicle_location_text_' + index">
          <app-tooltip [tooltip]="locationToolTipText" triggers="click hover :keydown.escape :keydown.tab"
            class="location-tooltip-mobile">
            <span>
              {{ locationText }}
            </span>
          </app-tooltip>
        </app-datalist-item>
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelVehicleLocation') }}" *ngIf="
        !bidItem.storageLocation ||
        bidItem.storageLocation.city === '' ||
        bidItem.storageLocation.state === '' ||
        !bidItem.storageLocation.city ||
        !bidItem.storageLocation.state
      " value="N/A">
        </app-datalist-item>
      </ng-template>

      <ng-template #tips>
        <ng-container class="d-flex flex-row">
          <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelBuyerTips') }}">
            <app-buyer-tips [itemId]="bidItem.inventoryItemUuid" [isVDP]="false" [buyerTips]="bidItem.buyerTips"
              [selectPDFtext]="selectPDFtext">
            </app-buyer-tips>
          </app-datalist-item>
        </ng-container>
      </ng-template>
      <ng-template #odometer>
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelOdometer') }}" [value]="getOdometer"
          [identifier]="'vehicle_odometer_text_' + index"></app-datalist-item>
      </ng-template>

      <!-- Suppressed under all-in pricing, as on both VDPs: the required fees are inside the price
           figures above, so this row's total puts the same money on screen twice.

           M3 left it alone for a reason that was structural rather than editorial -- the row HOSTS the
           transportation and fee-schedule links, so hiding it hid two things the buyer still needs.
           #FEELINKS is those links lifted out of #TOOLTIP, which removes the reason; the all-in branch
           renders them without the row, together with the transportation amount. That amount is what
           the row used to be the only carrier of, and the all-in price deliberately excludes it.

           showFeeRows is false only when all-in pricing is actually APPLIED, so a shared list and a
           purchased vehicle keep the row unchanged. -->
      <ng-template #serviceFee>
        <div class="service-fee-details">
          <ng-container *ngIf="showFeeRows; else ALLINFEEDETAILS">
            <ng-container *ngIf="getFeeSize() > 1; else SERVICEFEESINGLE">
              <ng-container *ngIf="!taxesPresent(); else TAXES">
                <app-datalist-item
                  [identifier]="'bid_list_service_fee_text_' + index"
                  label="{{ convert('vehicles.bidlistInventoryItem.labelFees') }}"
                  value="{{ getTotalFee() }}"
                >
                  <ng-container *ngTemplateOutlet="TOOLTIP"></ng-container>
                </app-datalist-item>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>

      <!-- The all-in branch. The transportation row hosts the fee-schedule links, exactly as
           #SERVICEFEESINGLE hosts them.

           SAT-94660 removed the *ngIf that used to drop this row, and with it the standalone-links
           fallback underneath. This template renders only where showFeeRows is false, which is the same
           condition the guard reduced to, so it was always true here and the fallback was unreachable --
           a listing with a fee schedule and no quoted transportation fee gets the row saying N/A, not a
           bare link. The mobile LIST view has no transportation row: it shows Fees N/A, as the desktop
           table does. -->
      <ng-template #ALLINFEEDETAILS>
        <app-datalist-item
          [identifier]="'bid_list_transportation_fee_text_' + index"
          [label]="transportationFeeLabel"
          data-testid="bidlist-inventory-item-pricing-transportation-fee"
        >
          {{ transportationFeeDisplay }}
          <ng-container *ngTemplateOutlet="FEELINKS"></ng-container>
        </app-datalist-item>
      </ng-template>

      <ng-template #TAXES>
        <ng-container *ngIf="showFeesAndTaxes(); else TOOLTIPNA">
          <app-datalist-item
            [identifier]="'bid_list_service_fee_text_' + index"
            label="{{ convert('vehicles.bidlistInventoryItem.feesAndTaxes') }}"
            value="{{ getTotalFee() }}"
          >
            <ng-container *ngTemplateOutlet="TOOLTIP"></ng-container>
          </app-datalist-item>
        </ng-container>

        <ng-template #TOOLTIPNA>
          <app-datalist-item
            identifier="bid_list_service_fee_text_"
            label="{{ convert('vehicles.bidlistInventoryItem.labelFees') }}"
            value="N/A">
          </app-datalist-item>
        </ng-template>
      </ng-template>

      <ng-template #TOOLTIP>
        <span [ngSwitch]="isMobile">
          <span *ngSwitchCase="true">
            <app-tooltip
              class="bidlist-fee-mob"
              [tooltip]="feeDetailsTooltip"
              [showToolTipAsHtml]="true"
              role="tooltip"
              triggers="click :keydown.escape :keydown.tab"
              (click)="analyticsInfo('Service Fee Details')"
              allytmln="Service Fee Details"
            >
              <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
            </app-tooltip>
            <br class="feeLink-break-line" />
            <ng-container *ngTemplateOutlet="FEELINKS"></ng-container>
          </span>
          <span *ngSwitchDefault>
            <app-tooltip
              [tooltip]="feeDetailsTooltip"
              [showToolTipAsHtml]="true"
              triggers="click :keydown.escape :keydown.tab"
              allytmln="Service Fee Details"
              (click)="analyticsInfo('Service Fee Details')"
            >
              <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
            </app-tooltip>
            <ng-container *ngTemplateOutlet="FEELINKS"></ng-container>
          </span>
        </span>
      </ng-template>

      <!-- Lifted out of #TOOLTIP by M4.16, unchanged. Only their position in the file has moved: the
           all-in path suppresses the fee row these were nested inside, and both links have to survive
           that. The mobile and desktop anchors differ in classes and in data-testid, so they stay as
           two anchors under the same ngSwitch rather than being merged into one.

           The <br> stays behind in #TOOLTIP: it separates the links from the tooltip icon, and on the
           all-in path there is no icon for it to separate them from. -->
      <ng-template #FEELINKS>
        <ng-container [ngSwitch]="isMobile">
          <ng-container *ngSwitchCase="true">
            <a data-testid="bidlist-inventory-item-pricing-transportation-fee-mobile-link" *ngIf="showTransportationFeeLink" href="#"
              class="pe-1 text-bold do-not-print mobileFeeLink transportation_fee_schedule_link"
              (click)="showTransportationFeeModal($event)" data-track-elem="button"
              data-track-name="TransportationFeeDetails" data-track-trigger="modal">{{
              convert('vehicles.bidlistInventoryItem.textTransportationFee') }}</a>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <a data-testid="bidlist-inventory-item-pricing-transportation-fee-link" *ngIf="showTransportationFeeLink" href="#"
              class="ps-2 pe-1 text-bold do-not-print transportation_fee_schedule_link"
              (click)="showTransportationFeeModal($event)" data-track-elem="button"
              data-track-name="TransportationFeeDetails" data-track-trigger="modal">{{
              convert('vehicles.bidlistInventoryItem.textTransportationFee') }}</a>
          </ng-container>
        </ng-container>
        <ng-container *ngTemplateOutlet="viewServiceFee"></ng-container>
      </ng-template>

      <ng-template #SERVICEFEESINGLE>
        <app-datalist-item *ngIf="hasFeeDetails()" [identifier]="'bid_list_service_fee_text'+ index"
          label="{{ bidlistInventoryItemTranslations.singleFeeLabel }}">
          {{ singleFeeAmount }}
          <br class="singleFee-feeLink-break-line" />
          <a *ngIf="showTransportationFeeLink" href="#" class="pe-1 text-bold do-not-print"
            (click)="showTransportationFeeModal($event)" data-track-elem="button"
            data-track-name="TransportationFeeDetails" data-track-trigger="modal">{{
            convert('vehicles.bidlistInventoryItem.textTransportationFee') }}</a>
          <ng-container *ngTemplateOutlet="viewServiceFee"></ng-container>
        </app-datalist-item>
        <app-datalist-item *ngIf="!hasFeeDetails()" [identifier]="'bid_list_service_fee_text'+ index"
          label="{{ convert('vehicles.bidlistInventoryItem.labelFees') }}" value="N/A">
        </app-datalist-item>
      </ng-template>

      <ng-template #disclosures>
        <ng-container class="data-list-with-tooltip-container">
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelDisclosures') }}"
          [identifier]="'vehicle_disclosures_text_' + index" class="yellow-lights-disclosures">
          <ng-container *ngIf="hasConditionIndicators; else noContent" class="d-flex flex-row">
            <app-condition-indicator variant="red" *ngIf="hasRedLight" small="true"
              [conditionIndicatorTranslations]="bidlistInventoryItemTranslations.conditionIndicatorTranslations"></app-condition-indicator>
              <app-vehicle-disclosures-indicator variant="yellow" *ngIf="hasYellowLight"
                small="true"
                [vehicleDisclosuresIndicatorTranslations]="bidlistInventoryItemTranslations.conditionIndicatorTranslations"
                [vehicleDisclosuresCount]="yellowLightDisclosureList.length" [bulletedToolTipContentToolTipOverCount]=true
                [vehicleDisclosuresList]="yellowLightDisclosureList">
            </app-vehicle-disclosures-indicator>
            </ng-container>
        </app-datalist-item>
        </ng-container>
      </ng-template>

      <ng-template #openingPrice>
        <ng-container *ngIf="bidItem.openingPrice">
          <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelOpeningPrice') }}">
            <span [class]="'vehicle_opening_price_text_' + index">{{formatCurrency(displayCurrentAmount, false)}}</span>
            <app-tooltip class="drip-info-icon" *ngIf="showDripCurrentAmountTooltip && dripCurrentAmountTooltip"
              [tooltip]="dripCurrentAmountTooltip" [showToolTipAsHtml]="true"
              [triggers]="dripTooltipTriggers"
              [id]="'vehicle_opening_price_drip_icon_' + index"
              [attr.data-testid]="'bidlist-inventory-item-pricing-all-in-price-icon-' + index"
              (click)="analyticsInfo('All In Price Details')" allytmln="All In Price Details">
              <i class="allycon-info-outline text-primary do-not-print" aria-hidden="true"></i>
            </app-tooltip>
            <app-tooltip triggers="hover click :keydown.escape :keydown.tab" *ngIf="get('lowestPrice')" [tooltip]="{
            metaTitle: convert('vehicles.bidlistInventoryItem.tooltipOpeningPrice.metaTitle'),
            title: convert('vehicles.bidlistInventoryItem.tooltipOpeningPrice.title'),
            body: convert('vehicles.bidlistInventoryItem.tooltipOpeningPrice.body')
          }" [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelPriceChange')">
              <img class="low-price-indicator"
                src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-low-price-indicator.svg"
                alt="{{ convert('vehicles.bidlistInventoryItem.altLowestPriceIndicator') }}" />
            </app-tooltip>
          </app-datalist-item>
        </ng-container>

        <ng-container *ngIf="!bidItem.openingPrice">
          <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelCurrentBid') }}">
            <span [class]="'vehicle_current_bid_text_' + index">{{formatCurrency(displayCurrentAmount, false)}}</span>
            <app-tooltip class="drip-info-icon" *ngIf="showDripCurrentAmountTooltip && dripCurrentAmountTooltip"
              [tooltip]="dripCurrentAmountTooltip" [showToolTipAsHtml]="true"
              [triggers]="dripTooltipTriggers"
              [id]="'vehicle_current_bid_drip_icon_' + index"
              [attr.data-testid]="'bidlist-inventory-item-pricing-all-in-price-icon-' + index"
              (click)="analyticsInfo('All In Price Details')" allytmln="All In Price Details">
              <i class="allycon-info-outline text-primary do-not-print" aria-hidden="true"></i>
            </app-tooltip>
            <app-tooltip triggers="hover click :keydown.escape :keydown.tab" *ngIf="get('lowestPrice')" [tooltip]="{
            metaTitle: convert('vehicles.bidlistInventoryItem.tooltipOpeningPrice.metaTitle'),
            title: convert('vehicles.bidlistInventoryItem.tooltipOpeningPrice.title'),
            body: convert('vehicles.bidlistInventoryItem.tooltipOpeningPrice.body')
          }" [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelPriceChange')">
              <img class="low-price-indicator"
                src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-low-price-indicator.svg"
                alt="{{ convert('vehicles.bidlistInventoryItem.altLowestPriceIndicator') }}" />
            </app-tooltip>
          </app-datalist-item>
          <ng-container *ngIf="
          bidItem.autoBidAllowed &&
          isAutoBidEnabled &&
          bidItem.autoBidAmount &&
          bidItem.autoBidAmount >= bidItem.currentAmount
        ">
            <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelAutoBidAmount') }}">
              <span [id]="'vehicle_auto_bid_text_' + index">{{formatCurrency(displayAutoBidAmount, false)}}</span>
            </app-datalist-item>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #lastBidAmount>
        <ng-container *ngIf="!bidItem.openingPrice">
          <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelLastBidAmount') }}">
            <span [class]="'vehicle_last_bid_amount_text_' + index">{{ formatCurrency(bidItem.dealershipLastBidAmount, false) }}</span>
          </app-datalist-item>
        </ng-container>
      </ng-template>

      <ng-template #spread>
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelSpreadTobook') }}">
          <ng-container *ngIf="getSpreadToBookValue(); else noContent">
            <span class="me-1" [id]="'vehicle_spread_to_book_text_' + index">{{ getSpreadToBookValue() * 100 | number:
              '1.0-0' }}%</span>

            <span [ngSwitch]="isMobile">
              <span *ngSwitchCase="true">
                <app-tooltip [tooltip]="spreadToBookTooltip" class="spread-to-book__tooltip"
                  triggers="click :keydown.escape :keydown.tab">
                  <i class="allycon-info-outline text-primary" aria-hidden="true"></i>
                </app-tooltip>
              </span>

              <span *ngSwitchCase="false">
                <app-tooltip [tooltip]="spreadToBookTooltip" class="spread-to-book__tooltip"
                  triggers="click hover :keydown.escape :keydown.tab">
                  <i class="allycon-info-outline text-primary" aria-hidden="true"></i>
                </app-tooltip>
              </span>

              <span *ngSwitchDefault>
                <app-tooltip [tooltip]="spreadToBookTooltip" class="spread-to-book__tooltip"
                  triggers="click hover :keydown.escape :keydown.tab">
                  <i class="allycon-info-outline text-primary" aria-hidden="true"></i>
                </app-tooltip>
              </span>
            </span>
          </ng-container>
        </app-datalist-item>
      </ng-template>

      <ng-template #status>
        <app-datalist-item *ngIf="showOfferButton()" label="{{ convert('vehicles.bidlistInventoryItem.labelStatus') }}"
          class="link" triggers="click :keydown.escape :keydown.tab" [identifier]="'vehicle_status_text_' + index">
          <a [attr.data-testid]="'bidlist-inventory-item-details-status-link-' + index" (click)="openOfferModals()" class="status-button link" [attr.aria-label]="
          convert('vehicles.bidlistInventoryItem.labelStatus') + (get('buyerPurchaseStatus') | parseString)
        " data-track-elem="button" data-track-trigger="modal"
            [attr.data-track-name]="get('buyerPurchaseStatus') | parseString" type="button" tabindex="0"
            (keyup.enter)="openOfferModals()">
            {{ convert(get('buyerPurchaseStatus') | parseString) }}
          </a>
        </app-datalist-item>
        <app-datalist-item *ngIf="!showOfferButton()" label="{{ convert('vehicles.bidlistInventoryItem.labelStatus') }}"
          [value]="convert(get('buyerPurchaseStatus') | parseString)" [identifier]="'vehicle_status_text_' + index">
        </app-datalist-item>
      </ng-template>

      <ng-template #offeredAmount>
        <app-datalist-item [ngStyle]="{ color: isSharedList ? '#d42825' : '' }"
          label="{{ convert(setOfferLabelValue()) }}" [identifier]="'vehicle_offered_amount_text_' + index">
          <span class="vehicle_offered_amount"> {{ formatCurrency(bidItem.offerAmount, false) }}</span>
        </app-datalist-item>
      </ng-template>

      <ng-template #winningOffer>
        <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelWinningAmount') }}"
          [identifier]="'vehicle_winning_offer_text_' + index">
          <span id="vehicle_winning_offer"> {{formatCurrency(bidItem.salePrice, false)}}</span>
        </app-datalist-item>
      </ng-template>

      <ng-template #auctionStatusTime>
        <app-datalist-item [label]="auctionStatusTimeLabel" [identifier]="'vehicle_end_time_text_' + index">
          <time *ngIf="showStartTime"> {{ localizeDateAndTime(auctionStartTime) }}</time>
          <time *ngIf="showEndTime"> {{ localizeDateAndTime(auctionEndTime) }}</time>
          <time *ngIf="showExtendedTime">
            {{ localizeDateAndTime(auctionExtendedTime) }} {{localTimeZoneNameExtended}}
          </time>

          <ng-container *ngIf="determineIndicator()">
            <app-tooltip [tooltip]="{
            title: convert('vehicles.bidlistInventoryItem.tooltipTimeIndicator.title'),
            body: indicatorBody
          }" triggers="click hover :keydown.escape :keydown.tab">
              <div class="tooltip-letter bg-dark text-white" role="tooltip" [attr.aria-label]="indicatorAriaLabel">
                <span aria-hidden="true">{{ indicatorCharacter }}</span>
              </div>
            </app-tooltip>
          </ng-container>
        </app-datalist-item>
      </ng-template>

      <ng-template #sellerOfferExpiry>
        <app-datalist-item [ngStyle]="{ color: isSharedList ? '#d42825' : '' }"
          label="{{ convert(setOfferExpiresValue()) }}"
          [identifier]="'vehicle_end_time_text_' + index">
          <time> {{ offerListExpiryDate ? localizeDateAndTime(offerListExpiryDate) : notAvailable }} </time>
        </app-datalist-item>
      </ng-template>

      <ng-template #totalPurchasePrice>
        <app-datalist-item [ngStyle]="{ color: isSharedList ? '#d42825' : '' }"
          label="{{ convert(setTotalLabelValue()) }}"
          [identifier]="'vehicle_total_purchase_price_' + index">
          {{ formatCurrency(getTotalPurchasePrice, showTotalPurchasePriceWithCents) }}
        </app-datalist-item>
      </ng-template>

      <ng-template #buyNow>
        <app-datalist-item label="{{ convert('common.labelBuyNowPrice') }}"
          [identifier]="'vehicle_buy_now_text_' + index">
          <ng-container *ngIf="isBuyNowPriceAvailable; else noContent">
            <span class="vehicle_buy_now_price"> {{ formatCurrency(displayBuyNowAmount, false) }}</span>
            <app-tooltip class="drip-info-icon" *ngIf="showDripBuyNowTooltip && dripBuyNowTooltip"
              [tooltip]="dripBuyNowTooltip" [showToolTipAsHtml]="true"
              [triggers]="dripTooltipTriggers"
              [id]="'vehicle_buy_now_drip_icon_' + index"
              [attr.data-testid]="'bidlist-inventory-item-pricing-all-in-buy-now-icon-' + index"
              (click)="analyticsInfo('All In Price Details')" allytmln="All In Price Details">
              <i class="allycon-info-outline text-primary do-not-print" aria-hidden="true"></i>
            </app-tooltip>
          </ng-container>
        </app-datalist-item>
      </ng-template>

      <ng-template #highBidder>
        <app-datalist-item class="ellipsis-overflow-higherBidder"
          label="{{ convert('vehicles.bidlistInventoryItem.labelHighBidder') }}"
          [identifier]="'vehicle_high_bidder_text_' + index">
          <app-tooltip [tooltip]="highBidderToolTip" triggers="click hover :keydown.escape :keydown.tab">
            <span class="vehicle_high_bidder_name" *ngIf="!isMobile && !isTablet">{{
              bidItem.highestBidderName | nameTruncate: 35
              }}</span>
            <span id="vehicle_high_bidder_name_tablet" *ngIf="!isMobile && isTablet">{{
              bidItem.highestBidderName | nameTruncate: 20
              }}</span>
            <span class="vehicle_high_bidder_name_mobile" *ngIf="isMobile && !isTablet">{{
              bidItem.highestBidderName | nameTruncate: 15
              }}</span>
            <i class="allycon-info-outline text-primary invisible" aria-hidden="true"></i>
          </app-tooltip>
        </app-datalist-item>
      </ng-template>

      <ng-template #dealership>
        <div *ngIf="selectedDealership && isLeadBuyer">
          <app-datalist-item identifier="{{ selectedDealership?.oeName }}"
            label="{{ convert('vehicles.bidlistInventoryItem.labelDealership') }}">
            <app-tooltip [tooltip]="selectedDealershipTooltip" triggers="click hover :keydown.escape :keydown.tab">
              <span class="vehicle_dealership_name" *ngIf="!isMobile && !isTablet">{{
                selectedDealership?.oeName | nameTruncate: 25
                }}</span>
              <span id="vehicle_dealership_tablet" *ngIf="!isMobile && isTablet">{{
                selectedDealership?.oeName | nameTruncate: 15
                }}</span>
              <span id="vehicle_dealership_mobile" *ngIf="isMobile && !isTablet">{{
                selectedDealership?.oeName | nameTruncate: 10
                }}</span>
            </app-tooltip>
            <ng-container *ngIf="isEditable && !isSharedList">
              <a data-testid="bidlist-inventory-item-pricing-dealership-edit-link" href="#" [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelDealershipOption')"
                class="ps-2 pe-1 edit-delivery__link text-bold align_middle bidlist_dealership_edit_link"
                (click)="openEditDealershipModal($event)" data-track-elem="button" data-track-name="Edit"
                data-track-trigger="modal">
                {{ convert('vehicles.bidlistInventoryItem.textEdit') }}</a>
            </ng-container>
          </app-datalist-item>
        </div>
      </ng-template>

      <ng-template #bidHistoryLink>
        <ng-container *ngIf="bidItem.purchaseType === 'WINNING_BID'">
          <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.ariaLabelBidHistory') | titlecase }}"
            class="link" triggers="click :keydown.escape :keydown.tab">
            <a data-testid="bidlist-inventory-item-pricing-bid-history-link" (click)="openBidHistoryModal()" class="status-button link"
              [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelBidHistory')" tabindex="0"
              data-track-name="bidHistory" (keyup.enter)="openBidHistoryModal()">
              {{ convert('vehicles.bidlistInventoryItem.ariaLabelBidHistory') | titlecase }}
            </a>
          </app-datalist-item>
        </ng-container>
      </ng-template>

      <ng-template #imagePlaceholder>
        <a *ngIf="urlBaseExternal" class="h5 inventory-item__title text-primary" [href]="vdpLink" target="_blank"
          [attr.aria-label]="
        title +
        ' - ' +
        (bidItem.buyerAuctionItemStatus | badgeStatus).text +
        convert('vehicles.bidlistInventoryItem.ariaLabelVehicleDetailPage')
      " data-track-elem="card id" [attr.data-track-name]="bidItem.inventoryItemUuid" tabindex="-1">
          <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520.45 309.41">
            <defs>
              <style>
                .cls-1 {
                  fill: #231f20;
                }

                .cls-2 {
                  fill: #cecece;
                }

                .cls-3 {
                  fill: #dbdbdb;
                }

                .cls-4 {
                  fill: #b5b5b5;
                }

                .cls-5,
                .cls-9 {
                  fill: none;
                }

                .cls-5 {
                  stroke: #a3a3a3;
                }

                .cls-5,
                .cls-6 {
                  stroke-miterlimit: 10;
                }

                .cls-6 {
                  fill: #fff;
                  stroke: #dbdbdb;
                }

                .cls-7 {
                  fill: #eaeaea;
                }

                .cls-8 {
                  fill: #424143;
                }

                .cls-9 {
                  stroke: #424143;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                  stroke-width: 1.1px;
                }
              </style>
            </defs>
            <title>car_placeholder</title>
            <path class="cls-1" d="M69.8,93.38" transform="translate(-66.96 -83.42)" />
            <path class="cls-2"
              d="M113.36,346s-43,4.52-46.34,13,126.52,39.76,204.46,32.88,112.32-17,112.32-17l38.52-23.4,150-43.85L538.06,267.3,456,284.41Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M91.1,237.71c5.68,1.67,18.18-.79,18.18-0.79l0.83-1.21"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M103.06,206.6" transform="translate(-66.96 -83.42)" />
            <path class="cls-4"
              d="M327.55,338l28.73-16.31c0-4,2.19-18.18,4.76-28.75,2.23-9.17,10.87-62.89,41.27-61.28C427.57,233,433,271.48,433,271.48c4.92,14.5,3.14,26.54,2.5,34.8s-2.35,64.16-48.39,68.61c-44.22,4.28-53.62-19.94-53.62-19.94A65,65,0,0,1,327.55,338Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M96.88,329.12s5.64,22.06,40.17,22.56c27.84,0.4,36.3-14.7,36.3-14.7"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M367.84,270.55c1.28-1.81,10.28-17.93,25.05-17.52,17.78,0.48,36.83,25.58,33.62,62.84s-26.12,45.72-34.69,45.92c-18.44.43-29.33-18.13-33-43.31a67,67,0,0,1-.57-13l3.4-14.66s0.8-5.14,1.61-6l0.8-3.93Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-4"
              d="M533.21,273.93c1.69,0,4.11-1.09,5.44-1.45s1.86,2.8,2.22,2.08,2.93,1.75,4,1.27,0-12,3.25-29,3.65-50.33,23.27-51.86c17.92-1.4,16.46,46.51,15.49,67.54s-5.2,32.14-5.2,32.14c-6,16.07-13.17,16.31-24.16,16.55s-19.57-.89-25-3.7c-7.8-4-10.47-15.23-10.47-15.23s-2-10.52-1.72-13.65S533.21,273.93,533.21,273.93Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M570.87,228.43c3.14,0,13.27,4,12.2,38.06-0.95,30.2-11.06,34.93-14,34.92-3.87,0-14.71,1.1-12.79-36.49C557.88,233.52,565.57,228.43,570.87,228.43Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-5" d="M557.27,309.61" transform="translate(-66.96 -83.42)" />
            <path class="cls-6"
              d="M584.09,199.89c-0.68-5.16.28-23.11-.58-27.7s-6.59-11.84-8.88-15.85-6.69-7.83-10.32-13.37l-22.92-35s-8.21-10.7-48.52-19.1-157.21-3.63-157.21-3.63-45.46-.38-75.84,13.18-74.31,53.49-74.31,53.49l-3.82,3.63s-28.08,8-30.95,9.17-9.93,1.72-13.37,2.1S114.46,171.42,98.79,184,73,229.21,71.67,236.56c-7.55,41.7,8.14,91.51,10.19,96.51s273.91,23.78,274.43,5.75,3.7-53.41,16.89-81.48c11.37-24.18,27.52-24.11,27.52-24.11s19.48-1.14,26.49,19C435,270.31,436,308.27,436,308.27l108.89-32.44s4.22-77.84,27-78.81c0,0,7.27,0,10.27,9S586,218.67,586,218.67,584.77,205,584.09,199.89ZM428.43,102.72c-2.67,5.86-31.07,52.59-31.07,52.59l-15.79,2.42-97.68-1.4s-43.68-.64-57.05-0.64-30.18-.64-30.18-0.64l-2.8-2.93s43.61-42.4,75.83-54.49l38-1.54,63.42-.76,49.28,1.4S431.11,96.86,428.43,102.72Zm118.94,25.95c-0.89,1.3-10.44,17.6-12.23,19.39s-5.22,5.48-13.5,6.49-39.22,4.58-39.22,4.58l-29,2.87a5.3,5.3,0,0,0-2.89-2.44l-11,.19L432.41,135c3.53-7.12,7.64-15.08,8.88-17.33,2.16-3.91,9.42-15.11,16.81-18s28.14-1.53,28.14-1.53,11.59-.13,29.54,5.48l18,5.6s3.06,1.53,3.82,2.55l8.91,12S548.27,127.37,547.38,128.67Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-7"
              d="M537.57,111.76c-0.76-1-3.82-2.55-3.82-2.55l-18-5.6c-18-5.6-29.54-5.48-29.54-5.48s-20.76-1.4-28.14,1.53-14.65,14.14-16.81,18c-1.24,2.25-5.35,10.21-8.88,17.33l7.1,24.72,11-.19a5.3,5.3,0,0,1,2.89,2.44l29-2.87s30.95-3.57,39.22-4.58,11.72-4.71,13.5-6.49,11.33-18.08,12.23-19.39-0.89-4.94-.89-4.94Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-7"
              d="M420.41,96.73l-49.28-1.4-63.42.76-38,1.54c-32.22,12.1-75.83,54.49-75.83,54.49l2.8,2.93s16.81,0.64,30.18.64,57.05,0.64,57.05.64l97.68,1.4,15.79-2.42s28.4-46.74,31.07-52.59S420.41,96.73,420.41,96.73Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M336.42,92.34C292.87,93.87,271.86,96,271.86,96s-4.58,0-17.77,7.45-34,22.73-40.69,28.46S187.24,155,187.24,155s-5.48,4.39-.64,5.41c10.33,2.17,25.66,1.08,25.66,1.08s110.22,2.29,127.41,2.1,43.89-2,50.31-2.7,14.26-2.27,19.51-12,15.2-27.89,19.87-36.29,11.16-18.34,11.16-18.34S380,90.81,336.42,92.34Zm92,10.38c-2.67,5.86-31.07,52.59-31.07,52.59l-15.79,2.42-97.68-1.4s-43.68-.64-57.05-0.64-30.18-.64-30.18-0.64l-2.8-2.93s43.61-42.4,75.83-54.49l38-1.54,63.42-.76,49.28,1.4S431.11,96.86,428.43,102.72Z"
              transform="translate(-66.96 -83.42)" />
            <polygon class="cls-3" points="470.3 61.7 470.3 61.7 470.3 61.7 470.3 61.7" />
            <polygon class="cls-3" points="475.24 53.78 475.24 53.78 475.23 53.79 475.24 53.78" />
            <path class="cls-3"
              d="M523.56,106l3,5.66c3,5.66,8,18.15,9.89,23.37a20.14,20.14,0,0,1,.77,10.06h0l4.94-7.92h0L526.6,107Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M481,97.89h0Z" transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M487.12,98.15l-2.22-.09,1.35,0.08h0.88Z" transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M504.6,156.57h0Z" transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M488.18,98.44l-0.09-.25-1,0h-0.88l-1.35-.08L481,97.89h0s3.82,12.54,8.09,28.64a228.66,228.66,0,0,1,5.81,31.16l9.67-1.12h0.07A211.65,211.65,0,0,0,498,128.95C493.41,113.9,488.86,100.43,488.18,98.44Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M188,139.52c-2.67,1.66-1.24,11.3-1.24,11.3l17.91-15.23C195.23,135,190.67,137.87,188,139.52Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M547.63,123s-5.47-7.64-8.34-11.85-9.49-6.2-9.49-6.2c-12.35-5.35-32.08-8.5-32.08-8.5-9.48-1.53-27-3.06-35.61-1.81s-16,9.17-18.58,13.18-17.52,33-17.52,33C421.24,150,422.58,167,422.58,167v2.67l14-.48,0.48-2.2s5.6,0.11,38.78-2.1c5.73-.38,7.17-4.59,7.17-4.59l40.52-4.48a19.78,19.78,0,0,0,13.25-7.74l2-3s8.69-14.2,9.93-16.46S547.63,123,547.63,123Zm-0.25,5.67c-0.89,1.3-10.44,17.6-12.23,19.39s-5.22,5.48-13.5,6.49-39.22,4.58-39.22,4.58l-29,2.87a5.3,5.3,0,0,0-2.89-2.44l-11,.19L432.41,135c3.53-7.12,7.64-15.08,8.88-17.33,2.16-3.91,9.42-15.11,16.81-18s28.14-1.53,28.14-1.53,11.59-.13,29.54,5.48l18,5.6s3.06,1.53,3.82,2.55l8.91,12S548.27,127.37,547.38,128.67Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M454.66,161.88a8.78,8.78,0,0,0,1.54.12l24.58-2.1a6.18,6.18,0,0,0,2.77-.89l-1.12.13Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M437,152.89v0.64c0.88,5.09,1.67,6.24,1.67,6.24l0.89,0L437,151.16A8.63,8.63,0,0,0,437,152.89Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M450.53,159.56h-0.41c1.58,0.22,2,1,2.7,1.59A5.18,5.18,0,0,0,450.53,159.56Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M487.52,145.83a11.11,11.11,0,0,0-9.55-7.74c-7.9-1.05-18.72-.48-24.07,0s-11,4.87-14.14,7.74a8.69,8.69,0,0,0-2.72,5.34l2.47,8.59c2,0,6.9-.14,9.29-0.24a7.22,7.22,0,0,1,1.31.05h0.41a5.18,5.18,0,0,1,2.29,1.6,2.69,2.69,0,0,0,.34.23,4.68,4.68,0,0,0,1.5.49l27.77-2.75,1.12-.13C488.6,155.88,487.52,145.83,487.52,145.83Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-8" d="M98.52,205.69" transform="translate(-66.96 -83.42)" />
            <path class="cls-1" d="M98.52,205.69" transform="translate(-66.96 -83.42)" />
            <path class="cls-8" d="M102.8,207.53" transform="translate(-66.96 -83.42)" />
            <path class="cls-9" d="M117.7,232.17" transform="translate(-66.96 -83.42)" />
            <path class="cls-7"
              d="M73.42,231.5c11.19,7.23,19.94,10.57,54,14.45,2.65,14.58,32.78,14.76,49.2,15.26s36.82,1.86,42.15-8.8c37.14,0,74-3.4,101.11-11.52,27.32-8.18,31.17-18.62,35.21-39.08-53.2,15.08-228.65,26.65-265.37-6.89C89.71,194.92,77.81,213.69,73.42,231.5Z"
              transform="translate(-66.96 -83.42)" />
          </svg>
        </a>
        <a *ngIf="!urlBaseExternal" class="h5 inventory-item__title text-primary" (click)="goToVdp()" target="_self"
          [attr.aria-label]="
        title +
        ' - ' +
        (bidItem.buyerAuctionItemStatus | badgeStatus).text +
        convert('vehicles.bidlistInventoryItem.ariaLabelVehicleDetailPage')
      " data-track-elem="card id" [attr.data-track-name]="bidItem.inventoryItemUuid + ' - VDP'">
          <svg data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520.45 309.41">
            <defs>
              <style>
                .cls-1 {
                  fill: #231f20;
                }

                .cls-2 {
                  fill: #cecece;
                }

                .cls-3 {
                  fill: #dbdbdb;
                }

                .cls-4 {
                  fill: #b5b5b5;
                }

                .cls-5,
                .cls-9 {
                  fill: none;
                }

                .cls-5 {
                  stroke: #a3a3a3;
                }

                .cls-5,
                .cls-6 {
                  stroke-miterlimit: 10;
                }

                .cls-6 {
                  fill: #fff;
                  stroke: #dbdbdb;
                }

                .cls-7 {
                  fill: #eaeaea;
                }

                .cls-8 {
                  fill: #424143;
                }

                .cls-9 {
                  stroke: #424143;
                  stroke-linecap: round;
                  stroke-linejoin: round;
                  stroke-width: 1.1px;
                }
              </style>
            </defs>
            <title>car_placeholder</title>
            <path class="cls-1" d="M69.8,93.38" transform="translate(-66.96 -83.42)" />
            <path class="cls-2"
              d="M113.36,346s-43,4.52-46.34,13,126.52,39.76,204.46,32.88,112.32-17,112.32-17l38.52-23.4,150-43.85L538.06,267.3,456,284.41Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M91.1,237.71c5.68,1.67,18.18-.79,18.18-0.79l0.83-1.21"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M103.06,206.6" transform="translate(-66.96 -83.42)" />
            <path class="cls-4"
              d="M327.55,338l28.73-16.31c0-4,2.19-18.18,4.76-28.75,2.23-9.17,10.87-62.89,41.27-61.28C427.57,233,433,271.48,433,271.48c4.92,14.5,3.14,26.54,2.5,34.8s-2.35,64.16-48.39,68.61c-44.22,4.28-53.62-19.94-53.62-19.94A65,65,0,0,1,327.55,338Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M96.88,329.12s5.64,22.06,40.17,22.56c27.84,0.4,36.3-14.7,36.3-14.7"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M367.84,270.55c1.28-1.81,10.28-17.93,25.05-17.52,17.78,0.48,36.83,25.58,33.62,62.84s-26.12,45.72-34.69,45.92c-18.44.43-29.33-18.13-33-43.31a67,67,0,0,1-.57-13l3.4-14.66s0.8-5.14,1.61-6l0.8-3.93Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-4"
              d="M533.21,273.93c1.69,0,4.11-1.09,5.44-1.45s1.86,2.8,2.22,2.08,2.93,1.75,4,1.27,0-12,3.25-29,3.65-50.33,23.27-51.86c17.92-1.4,16.46,46.51,15.49,67.54s-5.2,32.14-5.2,32.14c-6,16.07-13.17,16.31-24.16,16.55s-19.57-.89-25-3.7c-7.8-4-10.47-15.23-10.47-15.23s-2-10.52-1.72-13.65S533.21,273.93,533.21,273.93Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M570.87,228.43c3.14,0,13.27,4,12.2,38.06-0.95,30.2-11.06,34.93-14,34.92-3.87,0-14.71,1.1-12.79-36.49C557.88,233.52,565.57,228.43,570.87,228.43Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-5" d="M557.27,309.61" transform="translate(-66.96 -83.42)" />
            <path class="cls-6"
              d="M584.09,199.89c-0.68-5.16.28-23.11-.58-27.7s-6.59-11.84-8.88-15.85-6.69-7.83-10.32-13.37l-22.92-35s-8.21-10.7-48.52-19.1-157.21-3.63-157.21-3.63-45.46-.38-75.84,13.18-74.31,53.49-74.31,53.49l-3.82,3.63s-28.08,8-30.95,9.17-9.93,1.72-13.37,2.1S114.46,171.42,98.79,184,73,229.21,71.67,236.56c-7.55,41.7,8.14,91.51,10.19,96.51s273.91,23.78,274.43,5.75,3.7-53.41,16.89-81.48c11.37-24.18,27.52-24.11,27.52-24.11s19.48-1.14,26.49,19C435,270.31,436,308.27,436,308.27l108.89-32.44s4.22-77.84,27-78.81c0,0,7.27,0,10.27,9S586,218.67,586,218.67,584.77,205,584.09,199.89ZM428.43,102.72c-2.67,5.86-31.07,52.59-31.07,52.59l-15.79,2.42-97.68-1.4s-43.68-.64-57.05-0.64-30.18-.64-30.18-0.64l-2.8-2.93s43.61-42.4,75.83-54.49l38-1.54,63.42-.76,49.28,1.4S431.11,96.86,428.43,102.72Zm118.94,25.95c-0.89,1.3-10.44,17.6-12.23,19.39s-5.22,5.48-13.5,6.49-39.22,4.58-39.22,4.58l-29,2.87a5.3,5.3,0,0,0-2.89-2.44l-11,.19L432.41,135c3.53-7.12,7.64-15.08,8.88-17.33,2.16-3.91,9.42-15.11,16.81-18s28.14-1.53,28.14-1.53,11.59-.13,29.54,5.48l18,5.6s3.06,1.53,3.82,2.55l8.91,12S548.27,127.37,547.38,128.67Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-7"
              d="M537.57,111.76c-0.76-1-3.82-2.55-3.82-2.55l-18-5.6c-18-5.6-29.54-5.48-29.54-5.48s-20.76-1.4-28.14,1.53-14.65,14.14-16.81,18c-1.24,2.25-5.35,10.21-8.88,17.33l7.1,24.72,11-.19a5.3,5.3,0,0,1,2.89,2.44l29-2.87s30.95-3.57,39.22-4.58,11.72-4.71,13.5-6.49,11.33-18.08,12.23-19.39-0.89-4.94-.89-4.94Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-7"
              d="M420.41,96.73l-49.28-1.4-63.42.76-38,1.54c-32.22,12.1-75.83,54.49-75.83,54.49l2.8,2.93s16.81,0.64,30.18.64,57.05,0.64,57.05.64l97.68,1.4,15.79-2.42s28.4-46.74,31.07-52.59S420.41,96.73,420.41,96.73Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M336.42,92.34C292.87,93.87,271.86,96,271.86,96s-4.58,0-17.77,7.45-34,22.73-40.69,28.46S187.24,155,187.24,155s-5.48,4.39-.64,5.41c10.33,2.17,25.66,1.08,25.66,1.08s110.22,2.29,127.41,2.1,43.89-2,50.31-2.7,14.26-2.27,19.51-12,15.2-27.89,19.87-36.29,11.16-18.34,11.16-18.34S380,90.81,336.42,92.34Zm92,10.38c-2.67,5.86-31.07,52.59-31.07,52.59l-15.79,2.42-97.68-1.4s-43.68-.64-57.05-0.64-30.18-.64-30.18-0.64l-2.8-2.93s43.61-42.4,75.83-54.49l38-1.54,63.42-.76,49.28,1.4S431.11,96.86,428.43,102.72Z"
              transform="translate(-66.96 -83.42)" />
            <polygon class="cls-3" points="470.3 61.7 470.3 61.7 470.3 61.7 470.3 61.7" />
            <polygon class="cls-3" points="475.24 53.78 475.24 53.78 475.23 53.79 475.24 53.78" />
            <path class="cls-3"
              d="M523.56,106l3,5.66c3,5.66,8,18.15,9.89,23.37a20.14,20.14,0,0,1,.77,10.06h0l4.94-7.92h0L526.6,107Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M481,97.89h0Z" transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M487.12,98.15l-2.22-.09,1.35,0.08h0.88Z" transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M504.6,156.57h0Z" transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M488.18,98.44l-0.09-.25-1,0h-0.88l-1.35-.08L481,97.89h0s3.82,12.54,8.09,28.64a228.66,228.66,0,0,1,5.81,31.16l9.67-1.12h0.07A211.65,211.65,0,0,0,498,128.95C493.41,113.9,488.86,100.43,488.18,98.44Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M188,139.52c-2.67,1.66-1.24,11.3-1.24,11.3l17.91-15.23C195.23,135,190.67,137.87,188,139.52Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M547.63,123s-5.47-7.64-8.34-11.85-9.49-6.2-9.49-6.2c-12.35-5.35-32.08-8.5-32.08-8.5-9.48-1.53-27-3.06-35.61-1.81s-16,9.17-18.58,13.18-17.52,33-17.52,33C421.24,150,422.58,167,422.58,167v2.67l14-.48,0.48-2.2s5.6,0.11,38.78-2.1c5.73-.38,7.17-4.59,7.17-4.59l40.52-4.48a19.78,19.78,0,0,0,13.25-7.74l2-3s8.69-14.2,9.93-16.46S547.63,123,547.63,123Zm-0.25,5.67c-0.89,1.3-10.44,17.6-12.23,19.39s-5.22,5.48-13.5,6.49-39.22,4.58-39.22,4.58l-29,2.87a5.3,5.3,0,0,0-2.89-2.44l-11,.19L432.41,135c3.53-7.12,7.64-15.08,8.88-17.33,2.16-3.91,9.42-15.11,16.81-18s28.14-1.53,28.14-1.53,11.59-.13,29.54,5.48l18,5.6s3.06,1.53,3.82,2.55l8.91,12S548.27,127.37,547.38,128.67Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M454.66,161.88a8.78,8.78,0,0,0,1.54.12l24.58-2.1a6.18,6.18,0,0,0,2.77-.89l-1.12.13Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M437,152.89v0.64c0.88,5.09,1.67,6.24,1.67,6.24l0.89,0L437,151.16A8.63,8.63,0,0,0,437,152.89Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3" d="M450.53,159.56h-0.41c1.58,0.22,2,1,2.7,1.59A5.18,5.18,0,0,0,450.53,159.56Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-3"
              d="M487.52,145.83a11.11,11.11,0,0,0-9.55-7.74c-7.9-1.05-18.72-.48-24.07,0s-11,4.87-14.14,7.74a8.69,8.69,0,0,0-2.72,5.34l2.47,8.59c2,0,6.9-.14,9.29-0.24a7.22,7.22,0,0,1,1.31.05h0.41a5.18,5.18,0,0,1,2.29,1.6,2.69,2.69,0,0,0,.34.23,4.68,4.68,0,0,0,1.5.49l27.77-2.75,1.12-.13C488.6,155.88,487.52,145.83,487.52,145.83Z"
              transform="translate(-66.96 -83.42)" />
            <path class="cls-8" d="M98.52,205.69" transform="translate(-66.96 -83.42)" />
            <path class="cls-1" d="M98.52,205.69" transform="translate(-66.96 -83.42)" />
            <path class="cls-8" d="M102.8,207.53" transform="translate(-66.96 -83.42)" />
            <path class="cls-9" d="M117.7,232.17" transform="translate(-66.96 -83.42)" />
            <path class="cls-7"
              d="M73.42,231.5c11.19,7.23,19.94,10.57,54,14.45,2.65,14.58,32.78,14.76,49.2,15.26s36.82,1.86,42.15-8.8c37.14,0,74-3.4,101.11-11.52,27.32-8.18,31.17-18.62,35.21-39.08-53.2,15.08-228.65,26.65-265.37-6.89C89.71,194.92,77.81,213.69,73.42,231.5Z"
              transform="translate(-66.96 -83.42)" />
          </svg>
        </a>
      </ng-template>

      <ng-template #image>
        <a *ngIf="urlBaseExternal" class="h5 text-primary" [href]="vdpLink" target="_blank"
          [attr.aria-label]="title + convert('vehicles.bidlistInventoryItem.ariaLabelAcceptingVehicleDetailPage')"
          data-track-elem="button" [attr.data-track-name]="bidItem.inventoryItemUuid + ' - VDP'">
          <ng-content *ngTemplateOutlet="optimizedImage"></ng-content>
        </a>
        <a *ngIf="!urlBaseExternal" class="h5 text-primary" (click)="goToVdp()" target="_self"
          [attr.aria-label]="title + convert('vehicles.bidlistInventoryItem.ariaLabelAcceptingVehicleDetailPage')"
          data-track-elem="button"
          allytm-click-tagged="true">
          <ng-content *ngTemplateOutlet="optimizedImage"></ng-content>
        </a>
      </ng-template>


    </div>
  </ng-container>
  <ng-template #listview>
    <div class="listView-mobile">
      <app-table-card>
        <ng-container *ngIf="isSharedListCheckboxEnabled()">
          <div class="shared-list-checkbox-controls-list-view">
            <div *ngIf="isSharedListCheckboxEnabled()" [class]="checkboxClassList">
              <input data-testid="bidlist-inventory-item-listview-shared-checkbox" *ngIf="isActiveAuctionButtons()" type="checkbox" class="custom-control-input"
                [id]="'list-view-mobile-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelSelectVehicleCheckbox')"
                (click)="toggleVehicleCheckboxSelected()" [checked]="isVehicleCheckboxSelected" [disabled]="!isPendingBuyerAction()" />
              <label [for]="'list-view-mobile-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                class="custom-control-label"></label>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="isBidListCheckboxEnabled()">
          <div *ngIf="isBidListCheckboxEnabled()" class="shared-list-checkbox-controls-list-view">
            <div [class]="checkboxClassList">
              <input data-testid="bidlist-inventory-item-listview-bidlist-checkbox" type="checkbox" class="custom-control-input"
                     [id]="'list-view-mobile-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                     [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelSelectVehicleCheckbox')"
                     (click)="toggleVehicleCheckboxSelected()" [checked]="isVehicleCheckboxSelected" [disabled]="!isRemovableBidListItem()" />
              <label [for]="'list-view-mobile-bidlist-inventory-item-checkbox_' + bidItem.inventoryItemUuid"
                     class="custom-control-label"></label>
            </div>
          </div>
        </ng-container>
        <app-table-card-header>
          <div class="offer-list-card-header__title text-truncate">
            <h2>
              <a data-testid="bidlist-inventory-item-listview-title-link" allytm-click-tagged="true" [routerLink]="vdpLinkList"
              (click)="_analyticsService.trackEvent('link', this.bidItem.inventoryItemUuid + ' - VDP');">{{ titleList }}</a>
            </h2>
            <div class="d-flex flex-row">
              <span [attr.aria-label]="'VIN: ' + bidItem.itemDetail.vin">{{ bidItem.itemDetail.vin ? bidItem.itemDetail.vin : '' }}</span>
              @if(isInspectionSeriesEnabled) {
                <span class="ps-2 text-uppercase"><strong>{{translations.textInspectionSeries}}:</strong> {{ inspectionSeries }}</span>
            }
            </div>
          </div>
        </app-table-card-header>
        <app-table-card-body>
          <dl class="offer-list-card__info-list">
            <div class="offer-list-card-body__col">
              <dt>{{ bidlistInventoryItemTranslations.color.toUpperCase() }}:</dt>
              <dd>
                <span>{{ bidItem.itemDetail.color }}</span>
              </dd>
              <dt>{{bidlistInventoryItemTranslations.headerOdometer}}:</dt>
              <dd>
                <span>{{getOdometer}}</span>
              </dd>
            </div>
            <div class="offer-list-card-body__col">
              <ng-container *ngIf="isSharedList">
                <dt>{{ convert('vehicles.sharedListsListView.headerSellerOffer')}}:</dt>
                <dd [ngClass]="limitedOffer">
                  <span class="offer-amount-list-view" [class]="'vehicle_offer_amount_text_' + index">
                    {{bidItem.offerAmount ? formatCurrency(bidItem.offerAmount, false) : ''}}
                  </span>
                  <ng-container
                    *ngIf="isSharedList && bidItem.buyerAuctionItemStatus !== 'SOLD' && bidItem.buyerAuctionItemStatus !== 'WON' ">
                    <span class="seller-offer-details-tooltip">
                      <app-tooltip [tooltip]="sellerOfferTooltip" id="sellerOfferTooltip" [showToolTipAsHtml]="true"
                        triggers="hover :keydown.escape :keydown.tab" allytmln="Seller Offer Details">
                        <i class="allycon-clock ms-2 clock" aria-hidden="true"
                          [ngClass]="allyconClockClass"></i>
                      </app-tooltip>
                    </span>
                  </ng-container>
                </dd>
              </ng-container>
              <ng-container *ngIf="!isSharedList">
                <dt>{{ convert('vehicles.sharedListsListView.headerOpeningPrice') }}/{{ convert('vehicles.sharedListsListView.headerCurrentPrice') }}:</dt>
                <dd>
                  <span class="offer-amount-list-view" [class]="'vehicle_opening_price_text_' + index">{{formatCurrency(displayCurrentAmount, false)}}</span>
                  <app-tooltip class="drip-info-icon" *ngIf="showDripCurrentAmountTooltip && dripCurrentAmountTooltip"
                    [tooltip]="dripCurrentAmountTooltip" [showToolTipAsHtml]="true"
                    [triggers]="dripTooltipTriggers"
                    [id]="'vehicle_listview_opening_price_drip_icon_' + index"
                    [attr.data-testid]="'bidlist-inventory-item-listview-all-in-price-icon-' + index"
                    (click)="analyticsInfo('All In Price Details')" allytmln="All In Price Details">
                    <i class="allycon-info-outline text-primary do-not-print" aria-hidden="true"></i>
                  </app-tooltip>
                </dd>
              </ng-container>
              <!--
                Same rule as the card body and the desktop table: hidden while all-in pricing is
                actually applied, because the required fees are inside the price above. The pair below
                takes its place with N/A, as list-row-inventory-item's <td> does.
              -->
              <ng-container *ngIf="showFeeRows">
                <dt>{{ convert('vehicles.sharedListsListView.headerFees') }}:</dt>
                <dd>
                  {{ getTotalFee() }}
                  <ng-container>
                    <span class="fee-details-tooltip">
                      <app-tooltip [tooltip]="feeDetailsTooltip" [showToolTipAsHtml]="true" role="tooltip"
                        triggers="click :keydown.escape :keydown.tab" allytmln="Service Fee Details"
                        (click)="analyticsInfo('Service Fee Details')">
                        <i class="allycon-help-outline text-primary do-not-print" aria-hidden="true"></i>
                      </app-tooltip>
                    </span>
                  </ng-container>
                </dd>
              </ng-container>
              <!--
                SAT-94660 (QA rows 15 and 31): under all-in pricing the mobile list view mirrors the
                desktop table, which keeps its Fees header and falls to N/A in that cell. Same header key
                as common-list's <th>; `notAvailable` rather than the desktop cell's literal so the
                Canadian French bundle reads 'S/O'.
              -->
              <ng-container *ngIf="!showFeeRows">
                <dt>{{ convert('vehicles.sharedListsListView.headerFees') }}:</dt>
                <dd data-testid="bidlist-inventory-item-listview-fees-not-available">
                  {{ notAvailable }}
                </dd>
              </ng-container>
                <!--
                  The mobile rendering of the list view. Same rule as the desktop table in
                  list-row-inventory-item: shared list only (SAT-94660).
                -->
                <ng-container *ngIf="isSharedList">
                  <dt>{{ convert('vehicles.sharedListsListView.headerTotalPurchasePrice') }}</dt>
                  <dd data-testid="bidlist-inventory-item-listview-total-purchase-price">
                    {{ formatCurrency(getTotalPurchasePrice, showTotalPurchasePriceWithCents) }}
                  </dd>
                </ng-container>
                  <dt>
                <ng-container *ngIf="showDelivery">{{ convert('vehicles.sharedListsListView.headerDelivery') }}:
                </ng-container>
                <ng-container *ngIf="showShippingQuote">{{ convert('vehicles.sharedListsListView.headerShipping') }}:
                </ng-container>
              </dt>
              <dd class="delivery">
                <ng-container *ngIf="showDelivery">
                  <ng-container *ngIf="isDeliveryEditable else nonEditable">
                    <a data-testid="bidlist-inventory-item-listview-delivery-link" href="#" (click)="openEditDeliveryModal($event, true)" class="edit-delivery__link text-bold"
                      aria-label="Edit Delivery" data-track-elem="button" data-track-name="Delivery | Edit"
                      data-track-trigger="modal">{{
                      getTranslatedLocalDeliveryString(bidItem.localDelivery) }}</a>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="showShippingQuote">
                  <app-transportation-estimate [transportationQuote]="bidItem.transportationQuote"
                    [transportationTranslate]="bidlistInventoryItemTranslations.transTranslations" mode="estimate"
                    [showDeliveryLink]="isDeliveryLinkDisplayed" [index]="index"
                    [inventoryItemUuid]="bidItem.inventoryItemUuid"
                    (fireEventOnClick)="fireEventOnAnchorClick($event)">
                  </app-transportation-estimate>
                </ng-container>
              </dd>
              <dt>{{ convert('vehicles.sharedListsListView.headerCreditLine') }}:</dt>
              <dd>
                <span *ngIf="!isEditable || showFinanceSourceNotPopover">{{ financeSourceName }}</span>
                <app-finance-sources-popover *ngIf="showFinanceSourcesPopover" [tenantName]="tenantName"
                  [selectedFinanceSource]="selectedFinanceSource" [financeSources]="scopedFinanceSources"
                  [auctionItemStatus]="bidItem.auctionItemStatus" (sourceSelected)="updateFinanceSource($event)">
                </app-finance-sources-popover>
                <p class="mb-0 error-message text-bold text-destructive" *ngIf="hasFinanceInlineError"
                  aria-live="polite" aria-atomic="true">
                  {{ financeInlineError }}
                </p>
                <span *ngIf="isEditable && !selectedFinanceSource">N/A</span>
              </dd>
              <dt>{{ convert('vehicles.sharedListsListView.headerStatus') }}:</dt>
              <dd>
                <span>{{ (bidItem.buyerAuctionItemStatus | badgeStatus).text }}</span>
              </dd>
            </div>
          </dl>
        </app-table-card-body>
        <div class="inventory-item__actions-btn">
          <ng-container>
            <ng-container *ngIf="isSharedList && activeAuctionButtons">
              <ng-content *ngTemplateOutlet="mobileActiveAuctionButtons"></ng-content>
            </ng-container>
            <ng-container *ngIf="!isSharedList">
              <ng-content *ngTemplateOutlet="mobileWithdrawButton"></ng-content>
              <ng-content *ngTemplateOutlet="mobileBidButton"></ng-content>
            </ng-container>
            <ng-content *ngTemplateOutlet="mobileOfferButton"></ng-content>
            <ng-container *ngIf="!isSharedList">
              <ng-content *ngTemplateOutlet="mobileBuyNowButton"></ng-content>
            </ng-container>
          </ng-container>
        </div>
      </app-table-card>
    </div>
  </ng-template>

  <ng-template #creditLine>
    <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelCreditLine') }}"
      [identifier]="'vehicle_credit_line_link_' + index">
      <span *ngIf="!isEditable || showFinanceSourceNotPopover" class="credit-line-no-edit">{{ financeSourceName }}</span>
      <app-finance-sources-popover title="{{financeSourceName}}" *ngIf="showFinanceSourcesPopover"
        [tenantName]="tenantName" [selectedFinanceSource]="selectedFinanceSource" [financeSources]="scopedFinanceSources"
        [auctionItemStatus]="bidItem.auctionItemStatus" (sourceSelected)="updateFinanceSource($event)">
      </app-finance-sources-popover>
      <p class="mb-0 error-message text-bold text-destructive" *ngIf="hasFinanceInlineError" aria-live="polite"
        aria-atomic="true">
        {{ financeInlineError }}
      </p>
      <span *ngIf="isEditable && !selectedFinanceSource">N/A</span>
    </app-datalist-item>
  </ng-template>

  <ng-template #noIncluded>
    <span [id]="'vehicle_delivery_option_value_text_' + index">{{
      convert('vehicles.bidlistInventoryItem.textNo')
      }}</span>
    <ng-container *ngIf="isEditable && localDealer">
      <a href="#" (click)="openEditDeliveryModal($event, false)" class="ps-2 pe-1 edit-delivery__link text-bold"
        [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelDeliveryNotIncludeEdit')"
        data-track-elem="button" data-track-name="Delivery | Edit" data-track-trigger="modal">{{
        convert('vehicles.bidlistInventoryItem.textEdit') }}</a>
    </ng-container>
  </ng-template>

  <ng-template #nonEditable>
    {{getTranslatedLocalDeliveryString(bidItem.localDelivery)}}
  </ng-template>

  <ng-template #noContent>{{bidlistInventoryItemTranslations.deliveryStatusNotAvailable}}</ng-template>

  <ng-template #delivery>
    <app-datalist-item label="{{ convert('vehicles.bidlistInventoryItem.labelDelivery') }}">
      <ng-container *ngIf="
        showDelivery && get('localDelivery') !== null && get('localDelivery') !== '-' && localDealer;
        else noContent
      ">
        <ng-container *ngIf="get('localDelivery'); else noIncluded">
          <span [id]="'vehicle_delivery_option_value_text_' + index">{{
            convert('vehicles.bidlistInventoryItem.textYes')
            }}</span>
          <ng-container *ngIf="isEditable">
            <a href="#" (click)="openEditDeliveryModal($event, true)" class="ps-2 pe-1 edit-delivery__link text-bold"
              aria-label="Edit Delivery" data-track-elem="button" data-track-name="Delivery | Edit"
              data-track-trigger="modal">{{
              convert('vehicles.bidlistInventoryItem.textEdit') }}</a>
          </ng-container>
        </ng-container>
      </ng-container>
    </app-datalist-item>
  </ng-template>

  <ng-template #optimizedImage>
    <img [src]="imgUrlLarge" [alt]="convert('vehicles.bidlistInventoryItem.altTitle')" />
  </ng-template>

  <ng-template #desktopOfferButton>
    <button [attr.id]="
        (bidItem.buyerAuctionItemStatus | offerButtonText) === 'Make Offer'
          ? 'vehicle_make_offer_button_' + index
          : 'vehicle_view_offer_button_' + index
      " *ngIf="showOfferButton() && !isSharedList"
      class="btn btn-secondary bid-buttons ms-lg-auto bidItem-header-actionBtn purchase-action-btn" role="button"
      [disabled]="waitingForOffers" (click)="openOfferModals()"
      data-testid="bidlist-inventory-item-actions-offer-button"
      [attr.allytmln]="offerButtonAnalyticsText(bidItem.buyerAuctionItemStatus)"
      [attr.data-track-name]="bidItem.buyerAuctionItemStatus | offerButtonText" data-track-trigger="modal"
      data-track-elem="button" [attr.aria-label]="bidItem.buyerAuctionItemStatus | offerButtonText"
      [appTrackButton]="bidItem.buyerAuctionItemStatus | offerButtonText" #offerActionButton>
      {{ bidItem.buyerAuctionItemStatus | offerButtonText }}
    </button>

    <button [attr.id]="
        (bidItem.buyerAuctionItemStatus | offerButtonText) === 'Make Offer'
          ? 'vehicle_make_offer_button_' + index
          : 'vehicle_view_offer_button_' + index
      " *ngIf="showOfferButton() && isSharedList && !activeAuctionButtons"
      class="btn btn-primary bid-buttons ms-lg-auto bidItem-header-actionBtn purchase-action-btn" role="button"
      [disabled]="waitingForOffers" (click)="openOfferModals()"
      data-testid="bidlist-inventory-item-actions-shared-offer-button"
      [attr.allytmln]="offerButtonAnalyticsText(bidItem.buyerAuctionItemStatus)"
      [attr.data-track-name]="bidItem.buyerAuctionItemStatus | offerButtonText" data-track-trigger="modal"
      data-track-elem="button" [attr.aria-label]="bidItem.buyerAuctionItemStatus | offerButtonText"
      [appTrackButton]="bidItem.buyerAuctionItemStatus | offerButtonText" #offerActionButton>
      {{ bidItem.buyerAuctionItemStatus | offerButtonText }}
    </button>
  </ng-template>

  <ng-template #mobileOfferButton>
    <div class="inventory-item__actions-btn">
      <button data-testid="bidlist-inventory-item-actions-offer-mobile-button" *ngIf="showOfferButton() && !isSharedList" class="btn btn-secondary bid-buttons ms-lg-auto" role="button"
        (click)="openOfferModals()"
        [attr.allytmln]="offerButtonAnalyticsText(bidItem.buyerAuctionItemStatus)"
        [attr.data-track-name]="bidItem.buyerAuctionItemStatus | offerButtonText"
        data-track-trigger="modal" data-track-elem="button">
        {{ bidItem.buyerAuctionItemStatus | offerButtonText }}
      </button>

      <button data-testid="bidlist-inventory-item-actions-shared-offer-mobile-button" *ngIf="showOfferButton() && isSharedList && !activeAuctionButtons"
        class="btn btn-primary bid-buttons ms-lg-auto" role="button" (click)="openOfferModals()"
        [attr.allytmln]="offerButtonAnalyticsText(bidItem.buyerAuctionItemStatus)"
        [attr.data-track-name]="bidItem.buyerAuctionItemStatus | offerButtonText" data-track-trigger="modal"
        data-track-elem="button">
        {{ bidItem.buyerAuctionItemStatus | offerButtonText }}
      </button>
    </div>
  </ng-template>

  <ng-template #listViewOfferButton>
    <button [attr.id]="
        (bidItem.buyerAuctionItemStatus | offerButtonText) === 'Make Offer'
          ? 'vehicle_make_offer_button_' + index
          : 'vehicle_view_offer_button_' + index
      " *ngIf="showOfferButton() && (!isSharedList || !activeAuctionButtons)"
      class="btn btn-link text-primary decision-link" role="button" [disabled]="waitingForOffers"
      (click)="openOfferModals()"
      [attr.allytmln]="offerButtonAnalyticsText(bidItem.buyerAuctionItemStatus)"
      [attr.data-track-name]="bidItem.buyerAuctionItemStatus | offerButtonText"
      data-track-trigger="modal" data-track-elem="button"
      [attr.aria-label]="bidItem.buyerAuctionItemStatus | offerButtonText"
      [appTrackButton]="bidItem.buyerAuctionItemStatus | offerButtonText" #offerActionButton>
      {{ bidItem.buyerAuctionItemStatus | offerButtonText }}
    </button>
  </ng-template>

  <ng-template #desktopActiveAuctionButtons>
    <button [attr.data-testid]="'bidlist-inventory-item-actions-accept-button-' + index" [attr.id]="
    convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Accept Offer'
        ? 'vehicle_accept_offer_button_' + index
        : 'vehicle_view_offer_button_' + index
    " class="btn btn-primary bid-buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn ms-lg-auto"
      role="button" (click)="openSharedListCommonActionModal('ACCEPT')" [attr.allytmln]="allytmln.accept"
      data-track-trigger="modal" data-track-elem="button" [attr.aria-label]="convert('vehicles.counterOffer.btnAccept')"
      [appTrackButton]="convert('vehicles.counterOffer.btnAccept')" #offerActionButton>
      {{ convert('vehicles.counterOffer.btnAccept') | titlecase}}
    </button>
    <button [attr.data-testid]="'bidlist-inventory-item-actions-counter-button-' + index" *ngIf="this.vehicleTypeCode !== 'ISV'" class="btn btn-secondary bid-buttons short-bid-buttons bidItem-header-actionBtn purchase-action-btn"
      role="button" (click)="openSharedListCommonActionModal('COUNTER')" appTrackButton="Counter Offer"
      [attr.allytmln]="allytmln.counter" data-track-trigger="modal" data-track-elem="button"
      [attr.aria-label]="convert('vehicles.counterOffer.btnCounter')" [id]="'vehicle_buy_now_button_' + index">
      {{ convert('vehicles.counterOffer.btnCounter') | titlecase}}
    </button>
    <button [attr.data-testid]="'bidlist-inventory-item-actions-decline-button-' + index" *ngIf="this.vehicleTypeCode !== 'ISV'" [attr.id]="
    convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Decline Offer'
        ? 'vehicle_decline_offer_button_' + index
        : 'vehicle_view_offer_button_' + index
    " class="btn btn-secondary buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn ms-lg-auto"
      role="button" (click)="openSharedListCommonActionModal('DECLINE')" [attr.allytmln]="allytmln.decline"
      data-track-trigger="modal" data-track-elem="button"
      [attr.aria-label]="convert('vehicles.counterOffer.btnDecline')"
      [appTrackButton]="convert('vehicles.counterOffer.btnDecline')" #offerActionButton>
      {{ convert('vehicles.counterOffer.btnDecline') | titlecase}}
    </button>
  </ng-template>

  <ng-template #mobileActiveAuctionButtons>
    <div class="inventory-item__actions-btn">
      <button [attr.id]="
        convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Accept Offer'
            ? 'vehicle_accept_offer_button_' + index
            : 'vehicle_view_offer_button_' + index
        " class="btn btn-primary bid-buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn ms-lg-auto"
        role="button" (click)="openSharedListCommonActionModal('ACCEPT')" [attr.allytmln]="allytmln.accept"
        data-track-trigger="modal" data-track-elem="button"
        [attr.aria-label]="convert('vehicles.counterOffer.btnAccept')"
        [appTrackButton]="convert('vehicles.counterOffer.btnAccept')" #offerActionButton>
        {{ convert('vehicles.counterOffer.btnAccept') | titlecase}}
      </button>
    </div>

    <div class="inventory-item__actions-btn">
      <button *ngIf="this.vehicleTypeCode !== 'ISV'" class="btn btn-secondary bid-buttons short-bid-buttons bidItem-header-actionBtn purchase-action-btn"
        role="button" (click)="openSharedListCommonActionModal('COUNTER')" appTrackButton="Counter Offer"
        [attr.allytmln]="allytmln.counter" data-track-trigger="modal" data-track-elem="button"
        [attr.aria-label]="convert('vehicles.counterOffer.btnCounter')" [id]="'vehicle_buy_now_button_' + index">
        {{ convert('vehicles.counterOffer.btnCounter') | titlecase}}
      </button>
    </div>

    <div *ngIf="this.vehicleTypeCode !== 'ISV'" class="inventory-item__actions-btn">
      <button [attr.id]="
        convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Decline Offer'
            ? 'vehicle_decline_offer_button_' + index
            : 'vehicle_view_offer_button_' + index
        " class="btn btn-secondary buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn ms-lg-auto"
        role="button" (click)="openSharedListCommonActionModal('DECLINE')"
        [attr.data-track-name]="convert('vehicles.counterOffer.btnDecline')" data-track-trigger="modal"
        data-track-elem="button" [attr.allytmln]="allytmln.decline"
        [attr.aria-label]="convert('vehicles.counterOffer.btnDecline')"
        [appTrackButton]="convert('vehicles.counterOffer.btnDecline')" #offerActionButton>
        {{ convert('vehicles.counterOffer.btnDecline') | titlecase}}
      </button>
    </div>
  </ng-template>

  <ng-template #listViewActiveAuctionButtons>
    <button [attr.id]="
      convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Accept Offer'
          ? 'vehicle_accept_offer_button_' + index
          : 'vehicle_view_offer_button_accept' + index
      " class="btn btn-link text-primary decision-link" role="button"
      (click)="openSharedListCommonActionModal('ACCEPT')"
      [attr.data-track-name]="convert('vehicles.counterOffer.btnAccept')" data-track-trigger="modal"
      data-track-elem="button" [attr.allytmln]="allytmln.accept"
      [attr.aria-label]="convert('vehicles.counterOffer.btnAccept')"
      [appTrackButton]="convert('vehicles.counterOffer.btnAccept')" #offerActionButton tabindex="0">
      {{ convert('vehicles.counterOffer.btnAccept') | titlecase}}
    </button>
    <br>
    <button *ngIf="this.vehicleTypeCode !== 'ISV'" class="btn btn-link text-primary decision-link" role="button"
            (click)="openSharedListCommonActionModal('COUNTER')" appTrackButton="Counter Offer"
            [attr.allytmln]="allytmln.counter" data-track-trigger="modal" data-track-elem="button"
            [attr.aria-label]="convert('vehicles.counterOffer.btnCounter')" [id]="'vehicle_buy_now_button_' + index"
            tabindex="0">
      {{ convert('vehicles.counterOffer.btnCounter') | titlecase}}
    </button>
    <br>
    <button *ngIf="this.vehicleTypeCode !== 'ISV'"  [attr.id]="
      convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') === 'Decline Offer'
          ? 'vehicle_decline_offer_button_' + index
          : 'vehicle_view_offer_button_decline' + index
      " class="btn btn-link text-primary decision-link" role="button"
      (click)="openSharedListCommonActionModal('DECLINE')" [attr.allytmln]="allytmln.decline" data-track-trigger="modal"
      data-track-elem="button" [attr.aria-label]="convert('vehicles.counterOffer.btnDecline')"
      [appTrackButton]="convert('vehicles.counterOffer.btnDecline')" #offerActionButton tabindex="0">
      {{ convert('vehicles.counterOffer.btnDecline') | titlecase}}
    </button>
  </ng-template>

  <ng-template #desktopBuyNowButton>
    <button data-testid="bidlist-inventory-item-actions-buy-now-button" class="btn btn-secondary bid-buttons bidItem-header-actionBtn purchase-action-btn"
      (click)="openBuyNowModals()" *ngIf="showBuyNowButton()" appTrackButton="Buy Now" data-track-name="Buy Now"
      data-track-trigger="modal" data-track-elem="button"
      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow')"
      [id]="'vehicle_buy_now_button_' + index" tabindex="0">
      {{ convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') | titlecase }}
    </button>
  </ng-template>

  <ng-template #mobileBuyNowButton>
    <div class="inventory-item__actions-btn">
      <button data-testid="bidlist-inventory-item-actions-buy-now-mobile-button" class="btn btn-secondary bid-buttons" (click)="openBuyNowModals()" *ngIf="showBuyNowButton()"
        data-track-trigger="modal" data-track-name="Buy Now" data-track-elem="button" tabindex="0">
        {{ convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') | titlecase }}
      </button>
    </div>
  </ng-template>

  <ng-template #listViewBuyNowButton>
    <button class="btn btn-link text-primary decision-link" (click)="openBuyNowModals()" *ngIf="showBuyNowButton()"
      appTrackButton="Buy Now" data-track-name="Buy Now" data-track-trigger="modal" data-track-elem="button"
      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow')"
      [id]="'vehicle_buy_now_button_' + index" tabindex="0">
      {{ convert('vehicles.bidlistInventoryItem.ariaLabelbuyNow') | titlecase }}
    </button>
  </ng-template>

  <ng-template #desktopBidButton>
    <button data-testid="bidlist-inventory-item-actions-bid-button" class="btn btn-primary bid-buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn"
      appTrackButton="Bid" *ngIf="showBidButton()" data-track-name="Bid" data-track-elem="button"
      data-track-trigger="modal" (click)="openBidModal()"
      [attr.allytmln]="bidButtonAnalyticsText(bidItem.autoBidStatus)"
      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelBid')" [id]="'vehicle_bid_button_' + index"
      tabindex="0">
      {{ bidItem.autoBidStatus | autoBidButtonText }}
    </button>
  </ng-template>

  <ng-template #mobileBidButton>
    <div class="inventory-item__actions-btn">
      <button data-testid="bidlist-inventory-item-actions-bid-mobile-button" class="btn btn-primary bid-buttons"
        *ngIf="(bidItem.bidAllowed || (bidItem.autoBidAllowed && isAutoBidEnabled))" (click)="openBidModal()"
        [attr.allytmln]="bidButtonAnalyticsText(bidItem.autoBidStatus)"
        data-track-trigger="modal" data-track-name="Bid" data-track-elem="button" tabindex="0">
        {{ bidItem.autoBidStatus | autoBidButtonText }}
      </button>
    </div>
  </ng-template>

  <ng-template #desktopViewSimilarButton>
    <div *ngIf="isBidListMoaRecommendationsEnabled" class="inventory-item__actions-btn">
      <button class="btn btn-secondary bid-buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn w-100"
      (click)="openMoaRecommendations()"
        data-test-id="app-bidlist-inventory-item-e-view-similar-desktop-button" data-testid="bidlist-inventory-item-actions-view-similar-button"
        data-track-trigger="slideout-panel" data-track-name="View Similar" data-track-elem="button" tabindex="0">
        {{viewSimilarBtn}}
      </button>
    </div>
  </ng-template>

  <ng-template #mobileViewSimilarButton>
    <div *ngIf="isBidListMoaRecommendationsEnabled" class="inventory-item__actions-btn">
      <button class="btn btn-secondary bid-buttons"
        (click)="openMoaRecommendations()"
        data-test-id="app-bidlist-inventory-item-e-view-similar-mobile-button" data-testid="bidlist-inventory-item-actions-view-similar-mobile-button"
        data-track-trigger="slideout-panel" data-track-name="View Similar" data-track-elem="button" tabindex="0">
        {{viewSimilarBtn}}
      </button>
    </div>
  </ng-template>

  <ng-template #listViewBidButton>
    <button class="btn btn-link text-primary decision-link" appTrackButton="Bid" *ngIf="showBidButton()"
      data-track-name="Bid" data-track-elem="button" data-track-trigger="modal" (click)="openBidModal()"
      [attr.allytmln]="bidButtonAnalyticsText(bidItem.autoBidStatus)"
      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelBid')" [id]="'vehicle_bid_button_' + index"
      tabindex="0">
      {{ bidItem.autoBidStatus | autoBidButtonText }}
    </button>
  </ng-template>

  <ng-template #desktopWithdrawButton>
    <button data-testid="bidlist-inventory-item-actions-withdraw-button" class="btn btn-secondary bid-buttons bidItem-header-actionBtn short-bid-buttons purchase-action-btn"
      appTrackButton="Withdraw" *ngIf="bidItem.autoBidStatus === 'PENDING' && isAutoBidEnabled"
      data-track-name="Withdraw" data-track-elem="button" data-track-trigger="modal"
      (click)="openAutoBidWithdrawModal()"
      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw')"
      [id]="'vehicle_withdraw_button_' + index" tabindex="0">
      {{ convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw') | titlecase }}
    </button>
  </ng-template>

  <ng-template #mobileWithdrawButton>
    <div class="inventory-item__actions-btn">
      <button data-testid="bidlist-inventory-item-actions-withdraw-mobile-button" class="btn btn-secondary bid-buttons ms-lg-auto" appTrackButton="Withdraw"
        *ngIf="bidItem.autoBidStatus === 'PENDING' && isAutoBidEnabled" data-track-name="Withdraw"
        data-track-elem="button" data-track-trigger="modal" (click)="openAutoBidWithdrawModal()"
        [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw')"
        [id]="'vehicle_withdraw_button_' + index" tabindex="0">
        {{ convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw') | titlecase }}
      </button>
    </div>
  </ng-template>

  <ng-template #listViewWithdrawButton>
    <button class="btn btn-link text-primary decision-link" appTrackButton="Withdraw"
      *ngIf="bidItem.autoBidStatus === 'PENDING' && isAutoBidEnabled" data-track-name="Withdraw"
      data-track-elem="button" data-track-trigger="modal" (click)="openAutoBidWithdrawModal()"
      [attr.aria-label]="convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw')"
      [id]="'vehicle_withdraw_button_' + index" tabindex="0">
      {{ convert('vehicles.bidlistInventoryItem.ariaLabelWithdraw') | titlecase }}
    </button>
  </ng-template>
</ng-container>
